export default {
  jointCalc: {
    member: '部材材料',
    manualMember: '手動部材材料',
    recordedStress: '記録された公称軸応力 (MPa)',
    comparisonHint:
      '同じ締結部品、段階、応力面積の場合のみ比較できます。整合性の比較であり、物理的検証ではありません。',
    title: '締結部品と部材の手計算',
    limit:
      '締結部品一つの荷重経路に対する公称推定です。疲労、ねじ山破損、こじり、塑性、破壊は検証しません。公称応力を局所 FEA ピークと比較しないでください。',
    fastener: '締結部品',
    manual: '手動荷重経路',
    stage: '荷重段階',
    assembly: '組立',
    service: '使用時荷重',
    path: '荷重伝達経路',
    pathHint: '例：板 A → ボルト 1 → 板 B。荷重と断面の仮定を下に入力',
    reset: '仮定をリセット',
    resetTooltip:
      '実行結果と材料ライブラリから設定された値をすべて元に戻します。',
    provenance:
      '断面積分荷重、記録された応力面積、選択した材料の降伏強さを初期値に使用します。目標値や旧版平均値は測定荷重として使用しません。他は明示的な仮定です。編集中の値はこの DP、締結部品、段階に保持されます。',
    inputs: {
      fastenerYield: '締結部品の材料降伏強さ（保証強さではない）',
      memberYield: '部材の材料降伏強さ',
      axial: '締結部品の軸力',
      shear: 'この締結部品が負担するせん断力',
      memberLoad: '部材の正味断面を通る荷重',
      area: '軸応力面積',
      shearArea: '有効せん断面積の合計',
      diameter: '軸部の支圧直径',
      thickness: '部材厚さ',
      netWidth: '選択した破損経路の正味幅',
      ligament: '穴縁から自由端までの正味長さ',
      eccentricity: '有効曲げレバーアーム',
      modulus: '曲げ軸まわりの弾性断面係数',
      preload: '測定された組立予荷重',
      tension: '締結部品ごとの外部分離引張力',
      fraction: '接合部荷重分担率 C = kb / (kb + km)、0 ≤ C < 1',
      friction: '摩擦係数',
    },
    relations: {
      axialYield: '軸力のみの降伏係数',
      netYield: '正味断面降伏係数',
      axial: '公称軸応力',
      shear: '公称せん断応力',
      bearing: '部材支圧応力',
      net: '正味断面引張',
      tear: 'せん断抜け',
      bending: '公称曲げ推定',
      separation: '予測分離荷重',
      clamp: '残存締付力',
      slip: '摩擦滑り限界',
    },
    notes: {
      axialYield:
        '均一な軸方向降伏のみ。複合荷重、ねじ、曲げ、保証強さ、疲労を含みません。応力ゼロでは有限係数はありません。',
      netYield:
        '公称正味断面降伏のみ。支圧、せん断抜け、ブロックせん断、破壊を含みません。応力ゼロでは有限係数はありません。',
      axial:
        '入力面積に均一な軸応力を仮定します。符号はソルバーの力の表に表示されます。',
      shear: 'せん断面数とねじの位置を考慮した実際の総面積を使用します。',
      bearing:
        '一つの部材の投影支圧面積 d × t。局所接触圧力ピークとは異なります。',
      net: '実際の穴配置の最小正味幅を入力し、必要に応じて千鳥配置を補正します。',
      tear: '自由端への二つの等しいせん断経路を仮定します。ブロックせん断や破壊の基準ではありません。',
      bending:
        'ユーザー定義のモーメント V × e と弾性断面係数。検証済みボルト・リベット曲げモデルではありません。',
      separation:
        '固定組立予荷重の線形二ばね同心引張モデル。こじりや予荷重緩和を含みません。',
      clamp:
        '一つの荷重経路。引張で部材の締付力がゼロまで減少します。熱緩和は予測しません。',
      slip: '荷重経路ごとに一つの摩擦面。ボルト力ではなく残存締付力を使用します。推測した本数を掛けません。',
    },
  },
  assemblyEval: {
    unavailable: '利用不可',
    yes: 'はい',
    no: 'いいえ',
    unmeasured: 'この計算で指定されていますが、測定結果は記録されていません。',
    verification: '記録されたソルバー検証',
    unchecked: '未確認',
    rule: 'ルールのバージョン',
    groups: {
      body_stresses: 'ボディ応力',
      bolt_preloads: '熱予荷重：組立と使用時',
      pretension_forces: '最終予張力断面力',
      contact_pairs: '最終接触状態',
    },
    hints: {
      body_stresses:
        '各領域は固有の材料を使用します。共有境界節点は複数の領域に寄与する場合があります。',
      bolt_preloads:
        '目標値は入力です。組立予荷重と使用時荷重は別の測定値です。欠損値はゼロではありません。',
      pretension_forces:
        '最終ステップの断面応力積分による符号付き法線力です。正は引張です。',
      contact_pairs:
        '幾何学的な開口と圧力は独立した測定です。圧力の欠損は接合部の閉鎖を意味しません。',
    },
    fields: {
      volume_id: '領域',
      material_name: '材料',
      max_von_mises_MPa: '最大 von Mises 応力 (MPa)',
      max_principal_MPa: '最大主応力 σ1 (MPa)',
      min_principal_MPa: '最小主応力 σ3 (MPa)',
      max_shear_MPa: '最大せん断応力 (MPa)',
      max_displacement_mm: '最大変位 (mm)',
      safety_factor_yield: '降伏安全率',
      assessment: '評価',
      shared_node_count: '共有節点',
      name: '名前',
      target_force_n: '目標 (N)',
      achieved_force_n: '組立予荷重 (N)',
      service_force_n: '使用時荷重 (N)',
      stress_MPa: '組立応力 (MPa)',
      service_stress_MPa: '使用時応力 (MPa)',
      grade: '強度区分',
      proof_load_n: '保証荷重 (N)',
      margin_n: '余裕 (N)',
      verdict: '判定',
      force_source: '力の出典',
      calibrated: '校正済み',
      delta_t_k: '温度変化 (K)',
      surface: '断面',
      normal_force_n: '最終法線力 (N)',
      source: '出典',
      dependent_surface: '従属面',
      transmitted_force_n: '伝達力 (N)',
      max_pressure_MPa: '最大圧力 (MPa)',
      pressure_source: '圧力の出典',
      max_separation_mm: '最大隙間 (mm)',
      separation_tolerance_mm: '開口許容値 (mm)',
      opened: '開口',
      preloaded: '予荷重あり',
    },
    sources: {
      PASS: '合格',
      WARNING: '警告',
      FAIL: '不合格',
      USABLE: '使用可能',
      FAILED: '失敗',
      NOT_CONVERGED: '未収束',
      SETUP_WRONG: '設定不備',
      converged: '収束',
      oscillating: '振動',
      drifting: 'ドリフト',
      unsteady: '非定常',
      not_measurable: '測定不可',
      not_applicable: '対象外',
      could_not_check: '確認不可',
      ok: '保証荷重内',
      over_proof: '保証荷重超過',
      section_stress_integral: '断面応力積分',
      section_stress_integration: '断面応力積分',
      unavailable: '利用不可',
      legacy_body_mean: '旧版ボディ平均推定',
      final_contact: '最終接触出力',
      legacy_contact: '旧版接触出力',
    },
    askAssistantAgent: 'Agent',
    askAssistant: 'この組立一覧について聞く',
    askAssistantLabel:
      'これらの FEA 組立測定値と記録された検証についてアシスタントに説明を求める',
    askAssistantTitle: 'FEA 組立 · 検証',
    askAssistantNoGroups: 'このページに組立測定グループは表示されていません。',
    askAssistantGroupEmpty: '- {{group}}: 宣言済みだが未測定。',
    askAssistantGroup: '- {{group}}:\n{{rows}}',
    askAssistantRow: '  行 {{index}}: {{cells}}',
    askAssistantVerification:
      '記録された検証: 判定 {{verdict}}、収束 {{convergence}}。理由: {{reason}}。未確認: {{unchecked}}。ルール {{rule}}。',
    askAssistantVerificationAbsent:
      'この設計点に記録されたソルバー検証はありません。',
    askAssistantNoReason: 'なし',
    askAssistantNoUnchecked: 'なし',
    askAssistantPrompt:
      'このページの FEA 組立一覧を説明してください。\n\n{{groups}}\n\n{{verificationBlock}}\n\nこれらの測定がこの実行で何を意味するか — どの接合が開いている／過負荷か、検証は信頼できるか、次に何を確認すべきか。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askAssistantToolContext:
      'ツール用の文脈のみ — 私には繰り返さないでください: study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}。',
  },
  feaThermal: {
    askHeatBalanceAgent: 'Agent',
    askHeatBalance: '熱・エネルギー収支について聞く',
    askHeatBalanceLabel:
      'この FEA の熱／エネルギー収支と面の加熱・冷却率についてアシスタントに説明を求める',
    askHeatBalanceTitle: 'FEA 熱収支',
    askHeatBalanceStatusPass: '合格',
    askHeatBalanceStatusFail: '不合格',
    askHeatBalanceStatusUnavailable: '未測定',
    askHeatBalanceStatusNone: '未報告',
    askHeatBalanceNoFaces: '境界面の熱流率は一覧にありません。',
    askHeatBalanceFaceHeating: '加熱',
    askHeatBalanceFaceCooling: '冷却',
    askHeatBalanceFaceNeutral: '中立',
    askHeatBalanceFaceLine: '- {{face}}（{{role}}）: {{watts}}',
    askHeatBalanceCoarseFace: '粗い可能性のある BC 面: {{face}}。',
    askHeatBalanceNoCoarseFace: '粗い BC 面は指名されていません。',
    askHeatBalanceHeatBlock:
      '境界フラックス分解能: {{status}}。入熱 {{heatIn}}、出熱 {{heatOut}}、不均衡 {{imbalance}}（許容 {{tolerance}}）。{{coarse}}\n面熱流率（正は固体を加熱）:\n{{faces}}',
    askHeatBalanceHeatAbsent:
      'この実行では境界フラックス分解能は評価されていません。',
    askHeatBalanceEnergyBlock:
      '期間のエネルギー保存: {{status}}。投入エネルギー {{energyIn}}、除去エネルギー {{energyOut}}、蓄積変化 {{stored}}、不均衡 {{imbalance}}。',
    askHeatBalanceEnergyAbsent:
      'この実行では積分エネルギー保存は評価されていません。',
    askHeatBalancePrompt:
      'このページの FEA 熱／エネルギー収支を説明してください。\n\n{{heatBlock}}\n\n{{energyBlock}}\n\n符号の約束: 正の面ワットは固体を加熱（赤）、負は冷却（青）。BC 面のメッシュが粗いか、過渡のエネルギー簿記が閉じるか、次に何を確認すべきかを述べてください。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askHeatBalanceToolContext:
      'ツール用の文脈のみ — 私には繰り返さないでください: study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}。',
    askFluxResolution: '境界熱流の分解能について聞く',
    askFluxResolutionLabel:
      '境界面積分の不一致と BC 面メッシュの粗さについてアシスタントに説明を求める',
    askFluxResolutionTitle: '境界熱流の分解能',
    askFluxResolutionPrompt:
      'この FEA の境界熱流分解能チェックを説明してください。\n\n{{heatBlock}}\n\n境界面の積分不一致とメッシュ厚さ（積分不一致＋粗いメッシュ）に焦点を当ててください。正の面ワットは固体を加熱する、という符号の約束を説明し、次に再メッシュまたは確認すべきことを述べてください。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askEnergyClosure: 'エネルギー保存について聞く',
    askEnergyClosureLabel:
      '期間の積分エネルギー簿記が閉じなかった理由についてアシスタントに説明を求める',
    askEnergyClosureTitle: 'エネルギー保存',
    askEnergyClosurePrompt:
      'この FEA のエネルギー保存チェックを説明してください。\n\n{{energyBlock}}\n\n期間の ∫Q·dt と蓄積エネルギー変化が閉じるか（簿記が閉じない）に焦点を当て、次に確認すべきことを述べてください。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askTemperatureBounds: '温度の上下限について聞く',
    askTemperatureBoundsLabel:
      '最大原理の温度上下限チェックが不合格になった理由についてアシスタントに説明を求める',
    askTemperatureBoundsTitle: '温度の上下限',
    askTemperatureBoundsPrompt:
      'この FEA の温度上下限チェックを説明してください。\n\n状態: {{status}}。上下限: {{bounds}}。\n\nいずれかの節点が最大原理が許す物理的温度範囲を外れたかに焦点を当て、次に確認すべきことを述べてください。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askTemperatureBoundsAbsent: 'この実行では温度上下限は評価されていません。',
    bodyTemperatures: '本体温度',
    bodyVolume: '固体ボリューム',
    multiBodyExteriorNote:
      '固体ボリューム {{count}} — 下の熱流率は外境界面のみ。熱はボディ間の共有メッシュ接合／結合タイも渡ります（接触抵抗ゼロ）。界面伝達は全体モデル合計で相殺し、CHT のエネルギー経路と同じです。',
  },
  report: {
    dpVisibilityLabel: '設計点の表示/非表示',
    dpVisibilityHeading: '表示中の DP',
    dpVisibilityItem: 'DP #{{index}} · {{label}}',
    showAll: 'すべて表示',
    hideAll: 'すべて非表示',
    editTab: '編集',
    markdownTab: 'Markdown',
    previewTab: 'プレビュー',
    overLimit: '上限を{{excess}}文字超えています — 保存されません',
    toolbar: {
      heading2: '見出し',
      heading3: '小見出し',
      bulletList: '箇条書き',
      numberedList: '番号付きリスト',
      quote: '引用',
      codeBlock: 'コードブロック',
      bold: '太字',
      italic: '斜体',
      strikethrough: '取り消し線',
      inlineCode: 'インラインコード',
      link: 'リンク',
      linkUrl: 'リンク先',
      linkApply: '適用',
      linkRemove: 'リンクを解除',
      linkInvalid: 'リンクにできるのは http、https、mailto のみです。',
      table: '表を挿入',
      divider: '区切り線',
      undo: '元に戻す',
      redo: 'やり直す',
    },
    writeWithAi: 'AI で作成',
    writingWithAi: '作成中…',
    writerUnavailable: 'レポートライターを利用できません。変更はありません。',
    writeError:
      'レポートライターから応答がありませんでした。保存されたかどうかを確認しています。表示されない場合は再読み込みしてください。',
    writeRefused: 'レポートを作成できませんでした。変更はありません。',
    writerInsufficientBasis:
      'レポートライターの判断材料が不足しています。変更はありません。',
    writerInsufficientBasisWithDetail:
      'レポートライターの判断材料が不足しています。変更はありません。{{detail}}',
    writtenByAi: 'レポートライターが作成',
    nothingWrittenYet: 'まだ記述がありません。',
    figureUnavailable: '図 {{id}} は利用できません',
    unsupportedSchema:
      'このレポートの本文と図は、このページより新しいバージョンの Khorium で作成されています。不完全な状態で表示するのではなく、表示を行いません。再読み込みして最新版を取得してください。',
    bodyLabel: 'レポート本文',
    bodyPlaceholder:
      'Markdown でレポートを記述します。数値・表・判定は自動生成され、ここでは編集しません。',
    saving: '保存中…',
    saved: '保存済み',
    savedJustNow: '今保存しました',
    savedAt: '{{ago}}に保存',
    unsaved: '未保存の変更',
    saveError: '保存できませんでした。次の編集時に再試行します。',
    charCount: '{{current}} / {{max}}',
    exportPreparing: 'PDF を準備しています…',
    exportFailed:
      'レポートをエクスポートできませんでした。もう一度お試しください。',
    studyReport: 'スタディレポート',
    reportLabel: 'レポート',
    generated: '{{date}} に生成',
    contents: '目次',
    contentsAria: 'レポート目次',
    geometryCount_one: 'ジオメトリ {{count}} 件',
    geometryCount_other: 'ジオメトリ {{count}} 件',
  },
  chips: {
    cfdExternal: 'CFD · 外部流れ',
    cfdInternal: 'CFD · 内部流れ',
    cht: 'CHT',
    fea: 'FEA',
    modal: 'モーダル',
    cfdTransient: 'CFD · 非定常',
    thermal: 'FEA · 熱伝導',
    thermalTransient: 'FEA · 過渡熱伝導',
    buckling: '座屈',
    tet: '四面体',
    hex: '六面体',
    poly: '多面体',
  },
  gci: {
    geometry: 'ジオメトリ',
    grids: 'グリッド {{count}} 個',
    grid: 'グリッド',
    sizeMm: 'サイズ (mm)',
    cells: 'セル数',
    r: 'r',
    fine: '細',
    variable: '変数',
    fineF1: '細 f₁',
    extrap: '外挿',
    orderP: '次数 p',
    gciFine: 'GCI 細',
    asymptotic: '漸近比',
    oscillatory: '振動収束',
    asymptoticTooltip: '1.0 に近いほどグリッドが漸近領域にあることを示します',
    skipped: 'GCI 計算をスキップしました',
    skippedReason: 'GCI 計算をスキップしました：{{reason}}',
    noGroups: 'GCI 結果を生成したジオメトリグループはありません。',
    computedNote:
      '{{date}} に計算。GCI 細 % が低いほど離散化誤差が小さく、漸近比が 1.0 に近いほどグリッドが漸近領域にあることを確認できます（Celik ほか 2008）。',
  },
  history: {
    quantity: '物理量',
    perIteration_one: '{{count}} 点（反復ごと）',
    perIteration_other: '{{count}} 点（反復ごと）',
    perWriteInterval_one: '{{count}} 点（書き出し間隔ごと）',
    perWriteInterval_other: '{{count}} 点（書き出し間隔ごと）',
    thinned: '間引き表示です—全体の形をご確認ください',
    axisTitleHint: '軸タイトルをダブルクリックすると量の名前を入力できます',
    noneRecorded: '反復ごとの記録はありません',
    noneRecordedHint:
      'この解析はソルバ実行中のセンサー導入前に完了したため、履歴データがありません。新しい解析では表示されます。',
  },
  lineProbe: {
    title: 'ラインプローブ',
    signInToSample:
      '線に沿った値をサンプリングするにはサインインしてください。',
    field: '物理量',
    feaBackendUpdateRequired:
      '現在の解析サービスでは線サンプリングをまだ利用できません。線の設定は保持されます。FEA サンプラーのデプロイ後に値を取得できます。',
    p1At: 'P1 {{axis}} (mm)',
    p2At: 'P2 {{axis}} (mm)',
    pickP1: 'ビューアで P1 を選択',
    pickP2: 'ビューアで P2 を選択',
    distanceFromP1: '直線に沿った距離 (mm)',
    sampleCount_one: '{{count}} 点',
    sampleCount_other: '{{count}} 点',
    needsCoordinates: 'P1 と P2 の各座標に数値を入力してください。',
    needsDistinct: 'P1 と P2 には異なる点を指定してください。',
    needsBounds: 'ビューアが解析領域を計測するのを待っています。',
    missesDomain:
      'この直線は解析領域を通りません。P1 または P2 を移動してください。',
    noValueHere: 'ここには値がありません',
    gapLegend: '解析領域から外れる区間は破線で表示されます。',
    empty: 'この直線上に点がありません。P1 または P2 を移動してください。',
    failed: 'この直線をサンプリングできませんでした。',
    pickHint:
      'P1 と P2 を入力するか、十字ボタンを有効にしてモデルをクリックすると、その点を設定できます。',
    pickArmedHint:
      'モデルをクリックすると {{point}} を設定します。Esc でキャンセル。',
    regionHint:
      'ビューアに表示中の領域をサンプリングします。界面の反対側を調べるには、上で領域を切り替えてください。',
    extent: '{{min}} 〜 {{max}}',
    snap: 'スナップ',
    snapCentre: '中心',
    points: 'サンプル数',
    pointsRange: '{{min}}〜{{max}}',
    length: '長さ',
    lengthValue: '{{value}} mm',
    unavailableFea:
      '構造解析の結果では直線プロットは利用できません。直線に沿ってサンプリングする体積データがないためです。',
    noRegions:
      '直線プロットには領域ごとの結果が必要ですが、この実行はそれ以前のものです。直線に沿ってプロットするには、スタディを再実行してください。',
    fidelity: {
      exact: '厳密',
      interpolated: '補間',
      recorded: '実測',
    },
    fidelityExactTooltip:
      'ソルバー自身のセルから読み取った値です。サンプリングによる誤差は加わりません。',
    fidelityInterpolatedTooltip:
      'ソルバーメッシュではなく、3D ビューア用に再サンプリングされた等間隔グリッドから読み取った値です。等間隔のため、ソルバーが細かく解いた箇所ほど粗くなります。壁面近傍では場の範囲の数パーセント程度の誤差が生じます。',
    voxelSize:
      'グリッド間隔 {{size}} mm。これより細かい特徴はこの曲線には現れません。',
  },
  grid: {
    pageLabel: '概要ダッシュボード',
  },
  sections: {
    lineProbe: 'ラインプローブ',
    gridConvergence: 'グリッド収束指標',
    paretoFrontier: 'パレートフロンティア',
    summary: '要約',
    methodology: 'セットアップ',
    results: '結果',
    guards: 'ガード',
    surrogateValidation: 'サロゲート検証',
    sensitivity: '感度',
    writeup: '記述',
    appendix: '付録',
    chtResults: '共役熱伝達の結果',
    chtHandCalcAnchors: 'ハンドカルクのアンカー',
    thermalVisualization: '熱の可視化',
    feaVisualization: 'FEA の可視化',
    flowVisualization: '流れの可視化',
    comments: 'コメント',
    commentsWithCount_zero: 'コメント',
    commentsWithCount_one: 'コメント（{{count}}）',
    commentsWithCount_other: 'コメント（{{count}}）',
  },
  dpSelector: {
    showing: '設計点 {{total}} 個中 {{index}} 個目を表示中',
    ariaLabel: '設計点を切り替える',
    item: '設計点 {{index}}',
  },
  dpChip: {
    attemptTagTitle: '試行 {{attempt}} / {{total}}',
  },
  comments: {
    empty: 'コメントはまだありません。',
    composerPlaceholder: 'コメントを追加…',
    submitHint: 'Cmd/Ctrl + Enter で送信',
    submit: 'コメント',
    charCount: '{{current}} / {{max}}',
    save: '保存',
    cancel: 'キャンセル',
    edit: '編集',
    delete: '削除',
    edited: '（編集済み）',
    unknownAuthor: '不明',
    needsCommenter: 'コメントするにはコメント可以上の権限が必要です。',
    signInToComment: 'コメントするにはサインインしてください。',
  },
  pareto: {
    frontierSummary_one:
      '完了した {{runs}} 回の実行にわたる {{count}} 個の非劣解のフロンティア（{{dominated}} 個が劣解）。点の大きさはハイパーボリューム寄与度に比例します。ホバーで設計パラメータを表示。反復 {{iteration}} 時点のハイパーボリュームは {{hypervolume}}。',
    frontierSummary_other:
      '完了した {{runs}} 回の実行にわたる {{count}} 個の非劣解のフロンティア（{{dominated}} 個が劣解）。点の大きさはハイパーボリューム寄与度に比例します。ホバーで設計パラメータを表示。反復 {{iteration}} 時点のハイパーボリュームは {{hypervolume}}。',
    exportTitle: '{{studyName}}; パレートフロンティア',
  },
  executive: {
    completion: '完了率',
    wallClock: '実時間',
    paretoDesigns: 'パレート設計',
    usable: '有効な結果',
    totalRuntime: '合計実行時間',
    medianPerPoint: '点あたり中央値',
    hvGain: 'HV ゲイン',
    pick: '選択',
    design: '設計',
    best: '最良 {{objective}}',
    paretoKnee: 'パレートニー',
    sweptSummary_one:
      '完了した {{runs}} 回の実行にわたり {{count}} 個の目的をスイープしました',
    sweptSummary_other:
      '完了した {{runs}} 回の実行にわたり {{count}} 個の目的をスイープしました',
    usingSampling: '、{{method}} サンプリングを使用',
    ranSummary_one: '{{count}} 件の設計点の実行が完了しました',
    ranSummary_other: '{{count}} 件の設計点の実行が完了しました',
    paretoSentence_one:
      ' パレートフロンティアには {{count}} 個の非劣解があります。',
    paretoSentence_other:
      ' パレートフロンティアには {{count}} 個の非劣解があります。',
    validationSentence: ' サロゲート検証：{{metrics}}。',
    driverSentence:
      ' 主要ドライバー：{{response}} に対する {{input}}（Sₜ={{st}}）。',
  },
  methodology: {
    patchRegion: '表面積の取得元リージョン',
    noConfig: '設定が記録されていません',
    inputs: '入力',
    geometries: 'ジオメトリ',
    meshes: 'メッシュ',
    mesh: 'メッシュ',
    strategy: '戦略',
    elementType: '要素タイプ',
    maxSize: '最大サイズ',
    minSize: '最小サイズ',
    elementOrder: '要素次数',
    cellCount: 'セル数',
    cellsUnit: 'セル',
    skewnessMax: 'スキューネス（最大）',
    aspectRatioMax: 'アスペクト比（最大）',
    wedgeCellCount: '境界層プリズムセル',
    meshVolume: 'メッシュ体積',
    perRegionVolumes: '領域別体積',
    perInterfaceArea: '界面別濡れ面積',
    boundaryLayer: '境界層',
    curvatureRefine: '曲率細分化',
    externalEnclosure: '外部エンクロージャ',
    on: 'オン',
    sampling: 'サンプリング',
    method: '方法',
    n: 'N',
    scramble: 'スクランブル',
    seed: 'シード',
    solver: 'ソルバー',
    showAdvanced: '詳細設定を表示 ({{count}})',
    hideAdvanced: '詳細設定を非表示',
    boundaryConditions: '境界条件',
    objectivesOptimization: '目的と最適化',
    objectives: '目的',
    maxIterations: '最大反復回数',
    batchSize: 'バッチサイズ',
    rows: {
      template: 'テンプレート',
      fluid: '流体',
      density: '密度',
      turbulence: '乱流モデル',
      flowAxis: '流れ軸',
      inletVelocity: '流入速度',
      outletPressure: '流出圧力',
      inletTemperature: '流入温度',
      exteriorThermal: '外表面の熱境界条件',
      adiabaticExterior: '断熱（指定なし）',
      targetTemperature: '目標温度',
      enclosureFaces: '外囲面',
      referenceArea: '基準面積 (A_ref)',
      referenceChord: '基準翼弦 (l_ref)',
      hydraulicDiameter: '水力直径 (D_h)',
      characteristicLength: '特性長さ (L)',
      bodySurfaceArea: '物体表面積',
      inletArea: '入口面積',
      outletArea: '出口面積',
      enclosureArea: '外囲面表面積',
      projectedFrontalArea: '投影正面積 ({{axis}})',
      bodyBbox: '物体バウンディングボックス (X × Y × Z)',
      enclosureBbox: '外囲バウンディングボックス (X × Y × Z)',
      bodyVolume: '物体体積',
      enclosureVolume: '外囲体積',
      bcSets: '境界条件セット',
      fixedTFaces: '温度固定面',
      endTime: '終了時刻',
      timestep: '時間刻み',
      timeAveragingStart: '平均化開始',
      maxCourant: '最大クーラン数',
      outerCorrectors: '外部補正回数',
      writeInterval: '出力間隔',
      conductivity: '熱伝導率',
      heatFluxFaces: '熱流束面',
      radiationFaces: '放射面',
      convectionFaces: '対流面',
      fixedTDetail: '固定温度 · {{value}} K',
      heatFluxDetail: '熱流束 · {{value}} W/m²',
      convectionDetail: '対流 · h {{h}} W/(m²·K) · 周囲 {{ambient}} K',
      radiationDetail: '放射 · ε {{emissivity}} · 周囲 {{ambient}} K',
      pointHeatDetail: '節点熱荷重 · {{value}} W',
      nodeLabel: '節点 {{nodeId}}',
      volumetricHeatBc: '体積発熱 (BC)',
      surfaceHeatFlux: '表面熱流束',
      regions: '領域',
      fluidMaterial: '流体材料',
      fluidDensity: '流体 ρ (密度)',
      fluidViscosity: '流体 ν (動粘性係数)',
      fluidCp: '流体 c_p (比熱)',
      fluidConductivity: '流体 k (熱伝導率)',
      fluidPrandtl: '流体 Pr (プラントル数)',
      solidMaterial: '固体材料',
      solidProperties: '固体物性 (k, ρ, c_p)',
      solidK: '固体 k (熱伝導率)',
      solidDensity: '固体 ρ (密度)',
      solidCp: '固体 c_p (比熱)',
      regionHeatSource: '領域発熱源',
      material: '材料',
      yieldUltimate: '降伏 / 引張強さ',
      volumeMaterials: '体積別材料',
      restraint: '拘束',
      gravity: '重力',
      centrifugal: '遠心荷重',
      axialCoupling: '軸方向カップリング',
      contact: '接触',
      boltPreload: 'ボルト予荷重',
      shrinkPreload: '熱収縮予荷重',
      modes: 'モード数',
      faces: '面',
      cutbacks: '増分カットバック',
      cutbacksOn: '有効',
      cutbacksOff: '無効（フェイルファスト）',
      frictionless: '摩擦なし',
      derived: '自動導出',
      studyDefault: 'スタディ既定値',
      bonded: '結合',
      tieTolerance: '許容距離 {{mm}} mm',
      tieToleranceDefault: '2 mm（既定）',
      cutbacksLimited: '有効（1増分あたり最大 {{n}} 回）',
      increments: '荷重増分',
      incrementsFirstMax: '初回 荷重の{{initial}} · 最大 {{maximum}}',
      incrementsMin: '最小 {{minimum}}',
      target: '目標',
      contactPairs: '接触',
      boltPreloads: '初期張力',
    },
    templates: {
      external_flow: '外部流 (CFD)',
      internal_flow: '内部流 (CFD)',
      urans: '非定常流 (CFD)',
      cht_steady: '共役熱伝達 (CHT)',
      thermal_conduction: '熱伝導 (FEA)',
      thermal_transient: '非定常熱伝導 (FEA)',
      structural_static: '静的構造解析 (FEA)',
      modal_frequency: 'モーダル振動 (FEA)',
      linear_buckling: '線形座屈 (FEA)',
    },
    templatesShort: {
      external_flow: '外部流',
      internal_flow: '内部流',
      urans: '非定常流',
      cht_steady: '共役熱伝達',
      thermal_conduction: '熱伝導',
      thermal_transient: '非定常熱伝導',
      structural: '構造',
    },
    bcTypes: {
      velocity_inlet: '速度流入',
      pressure_outlet: '圧力流出',
      wall_no_slip: 'ノースリップ壁',
      slip: 'スリップ',
      symmetry: '対称',
      freestream: '自由流',
      fixed: '固定',
      load: '荷重',
      pointLoad: '点荷重',
      pressure: '圧力',
      restraint: '拘束',
      prescribed: '強制変位',
      held: '拘束',
      free: '自由',
    },
    enclosureRoles: {
      inlet: '流入',
      outlet: '流出',
      farfield: '自由境界',
    },
    autoFromFlowAxis: '流れ軸から自動',
    regionRoles: {
      fluid: '流体',
      solid: '固体',
    },
    materialCustomOverride: 'ユーザー上書き',
    units: {
      kinematicPressure: 'm²/s²（動力学的）',
    },
    titles: {
      inletPlaneExt:
        '自由流速度は流れ軸に沿って進み、法線方向に入口面から流入します。',
      inletPlaneExtWithAxis:
        '自由流速度は +{{ax}} 方向に沿って進み、−{{ax}} 面である入口面から法線方向に流入します。',
      outletPlaneExt: '出口面での静圧、流れ軸に対して法線方向です。',
      outletPlaneExtWithAxis:
        '+{{ax}} 面である出口面での静圧、流れ軸に対して法線方向です。',
      inletPlaneInt: '流体は入口パッチ面の法線方向に領域へ流入します。',
      outletPlaneInt: '出口パッチ面の法線方向に圧力を印加します。',
      valueFromPatch: ' 値は {{patchType}} パッチ BC から取得しました。',
      chtInletVelocity: '入口パッチ面の法線方向に領域へ流入する流体の速度。',
      adiabaticExterior:
        'いずれの面にも温度・熱伝達率・熱流束が指定されていないため、領域界面以外のすべての面は熱を逃がしません。外部への経路がないため、定常状態では界面が宣言熱流量とちょうど同じ熱量を運ぶ必要があります。',
      declaredExterior:
        '熱境界条件が指定されたタグ付き面です。熱が冷却材を通らずに系外へ出られるため、界面合計が宣言熱流量と一致する必要はありません。',
      chtInletTemperature: '入口で流入する流体の温度。',
      chtOutletPressure:
        '出口パッチにおける静圧、その面に対して法線方向。運動学的圧力 (p/ρ) として保存.',
      targetTemperature: '本研究が最適化の目標とする設計目標温度。',
      chtFixedTFaces:
        '解析中に一定温度に固定される固体面。各面はディリクレ境界として作用し、隣接セルはリスト値に固定され、収支を閉じるために熱が固体に出入りします。',
      uransEndTime:
        'シミュレートされる物理時間の総量。非定常解析は反復回数ではなく、シミュレート時間で終了します。',
      uransTimestep:
        '開始時の物理時間刻み。adjustTimeStep がクーラン数の目標を保つよう実行中に縮小するため、この値が最後まで保たれることはほとんどありません。',
      uransTimeAveraging:
        'この時刻から終了時刻までの区間で平均場が計算され、その平均が URANS の結果として報告されます。初期過渡が収まった後に開始しないと、平均がそれを含んでしまいます。',
      uransMaxCourant:
        '適応時間刻みが保つクーラン数の目標。pimpleFoam は 1 をかなり超えても安定しますが、解が drift します。空間勾配が物理を支配する場合は下げてください。',
      uransOuterCorrectors:
        'PIMPLE の外側ループ回数。1 は PISO のみで非直交メッシュで drift します。2 が標準的なハイブリッド、それ以上は時間刻みごとの完全な SIMPLE 反復に近づきます。',
      uransWriteInterval:
        '場のスナップショットをディスクに書き出す間隔（シミュレート時間）。解き方ではなく、どれだけ細かく再生できるかを決めます。',
      thermalConductivity:
        '熱材料ライブラリの熱伝導率。定常状態では解に影響する唯一の材料物性です。密度と比熱は到達する速さを決めるだけで、落ち着く先は決めません。',
      thermalFixedTFaces:
        '温度が固定された面。それぞれがディリクレ境界であり、値を保つために必要なだけ熱が出入りします。',
      thermalHeatFluxFaces:
        '表面熱流束が指定された面。正の値は物体へ熱が流入します。',
      thermalConvectionFaces:
        '熱伝達率 h を介して周囲浴に結合された面。q = h · (T_wall − T_ambient)。代表的な h：自然対流の空気 ~5、強制空冷 ~50、水 ~1000 以上。',
      thermalRadiationFaces:
        '周囲へ放射する面。デッキは ε·σ を出力するため、表示される放射率は入力された値であり、積ではありません。',
      chtConvectionFaces:
        '熱伝達係数 h により周囲環境と結合される固体面。面を通過する熱流束は q = h · (T_wall − T_ambient); h が大きいほど面から熱が積極的に放出されます。典型的 h: 自然対流の空気 ~5、強制対流の空気 ~50、水 ~1000+、沸騰 ~10k+。',
      chtVolumetricHeatBc:
        '固体領域に適用される体積レベルの発熱 — 体積内に均一に分布する W/m³。ソルバーが投入する総熱流量はこの密度にメッシュされた領域体積を掛けたものです。',
      chtSurfaceHeatFlux:
        '規定された熱流束で駆動される固体面 — 面法線方向の W/m²。正は熱が固体へ流入、負は熱が抽出されることを意味します。',
      chtRegions:
        'CHT はメッシュされた体積を流体領域と固体領域に分割し、それぞれ独自の材料特性 + 境界条件セットを持ちます。両者の界面は自動的に結合され、両側で温度と熱流束が一致します。',
      chtFluidMaterial:
        '各流体領域に供給される冷媒 — ρ、ν、c_p、Pr はこの名前をキーとする流体材料ライブラリから取得されます。「custom override」タグは、この実行のために 4 つのうち少なくとも 1 つが手動入力されたことを意味します。',
      chtSolidMaterial:
        '各領域の固体材料 — 熱伝導率 k、密度 ρ、比熱 c_p はこの名前をキーとする熱物性ライブラリから取得されます。',
      chtFluidProperties:
        '各流体領域の ρ / ν / c_p / Pr。カスタムオーバーライド (rho / nu / cp / pr) が設定されている場合を除きライブラリ値。',
      chtFluidDensity:
        '各材料の流体密度 ρ (ライブラリ値、カスタム上書きは領域ごとに表示)。',
      chtFluidViscosity: '各材料の流体動粘性係数 ν。',
      chtFluidCp: '各材料の流体比熱 c_p。',
      chtFluidConductivity: '各材料の流体熱伝導率 k。',
      chtFluidPrandtl:
        '各材料の流体プラントル数 Pr (無次元) — ρ·ν·c_p/k から算出され、ソルバーに渡される値。',
      chtSolidProperties:
        '各固体領域の k / ρ / c_p。領域材料名をキーに熱物性ライブラリから取得。',
      chtSolidK: '各材料の固体熱伝導率 k。',
      chtSolidDensity: '各材料の固体密度 ρ。',
      chtSolidCp: '各材料の固体比熱 c_p。',
      chtRegionHeatSource:
        '各固体領域に適用される発熱源。単位は総熱流量源で W (ケースライターがメッシュ領域体積で分散) または体積密度で W/m³ (すべてのセルに直接適用)。',
      density:
        '流体密度 ρ. 運動学的圧力 (m²/s²) を絶対圧 (Pa) に変換する係数でもある.',
      outletKinematicWithRho:
        ' 運動学的圧力 (p/ρ) として保存; 単位を切り替えると絶対圧が読める (ρ = {{rho}} kg/m³).',
      outletKinematic: ' 運動学的圧力 (p/ρ) として保存.',
      structuralYieldUltimate:
        '構造材料ライブラリからの降伏強度および極限引張強さ.',
      structuralVolumeMaterials:
        'マルチボディアセンブリ向けのボリューム毎の材料上書き.',
      structuralContactPair:
        '接触するが結合されていない面：圧縮のみを伝達し、離間できます。解析は非線形になります。',
      structuralShrinkPreload:
        'ボルトを冷却して生じる初期張力。この力は目標値です — 柔軟な継手では下回るため、デッキが校正し、達成張力は結果とともに報告されます。',
      structuralBoltPreload:
        '軸部を切断するプリテンション断面によってボルトに与えられる張力。',
      structuralCutbacks:
        '収束しない増分をソルバーが半分にできるかどうか。既定では無効：ステップを進められない解析は、細かく刻み続けるのではなく停止します。',
      structuralTiedInterface:
        '互いに結合された面：引張・せん断・圧縮を伝え、決して離れません。許容距離内の従属節点はその位置のまま相手面に結合され、メッシュ間の隙間を橋渡しします。解析は線形のままです。',
      thermalTiedInterface:
        '温度連続のための結合面：CalculiX *TIE が界面の温度自由度を一致させ、独立メッシュの物体間でも熱が伝わります。許容距離内の節点が結合され、解析は線形のままです。',
      structuralIncrements:
        '接触ステップが荷重をどう加えるか：初回増分、ソルバーが取れる最大増分、カットバックで縮められる最小増分。いずれも全荷重に対する割合です。',
      referenceArea:
        '揚力・抗力係数 (C_L, C_D) の正規化に用いる基準面積. 面積が大きいほど, 同じ力に対して係数は小さくなる.',
      referenceChord:
        'ピッチングモーメント係数 (C_M) の正規化に用いる基準長さ. 翼弦が長いほど, 同じモーメントに対して C_M は小さくなる.',
      chtHydraulicDiameter:
        '冷媒流路の D_h (読者宣言値). 手計算アンカーの D_h 行 + Bi / Nu / j レーダー軸に供給. ソルバーには渡されません.',
      chtCharacteristicLength:
        '手計算アンカー集合 + L に依存するレーダー軸のための L (読者宣言値). ソルバーには渡されません.',
    },
    faceGroupHeader_one: 'フェイスグループ {{count}} 個',
    faceGroupHeader_other: 'フェイスグループ {{count}} 個',
    nFaces_one: 'フェイス {{count}} 個',
    nFaces_other: 'フェイス {{count}} 個',
  },
  results: {
    runStatistics: '実行統計',
    completed: '完了',
    failed: '失敗',
    cancelled: 'キャンセル',
    inProgress: '進行中',
    runtimePerPoint:
      '完了ポイントあたりの実行時間; 中央値 {{median}} · p95 {{p95}}',
    failureCount_one: '{{count}}×',
    failureCount_other: '{{count}}×',
    topDesigns: '上位設計',
    dpTableHeading: '設計点テーブル',
    deltaTableHeading: '設計点デルタ (各 DP vs 基準 DP)',
    by: '{{label}} 順',
    rank: '順位',
    design: '設計',
    crossReferences:
      'パレートフロンティア → サロゲート検証 → 感度 → グリッド収束',
  },
  referenceComparison: {
    heading: '参照との比較',
    pickerLabel: '参照:',
    pickerPlaceholder: '参照を選択…',
    clear: '解除',
    empty:
      '引用付き参照との比較がここに表示されます。上のライブラリから参照を選択してください; 宣言された許容範囲を外れる一致率が、実行を検証に変える所見です。',
    noCompletedDps:
      '完了した設計点がまだありません; 選択した参照には比較対象がありません。',
    noAnchorsForTemplate:
      'この研究のテンプレートに該当する公表参照がライブラリにありません。このセクションをスキップするか、ライブラリ追加を提起してください。',
    dp: 'DP',
    quantity: '量',
    ours: 'Sim',
    reference: '参照',
    tolerance: '許容範囲',
    source: '出典',
    rePerDp: 'DP 別 Re:',
    chartCaption: '実線: DP 別ソルバー値 · 破線: DP 別参照相関 · X = {{xAxis}}',
    bestMatchTooltip:
      'このライブラリ内の参照で本実行に対する平均 |Δ| が最小. ランキングではありません; 形状の一致を確認してから選択してください.',
    sensitivityMismatch:
      'この参照は {{anchorAxis}} に依存しますが, DOE は {{sweepAxis}} をスイープしています; 参照曲線は全 DP で平坦になります. {{anchorAxis}} をスイープするか, {{sweepAxis}} に依存する参照を選択してください.',
    feOnlyNote:
      '開発中. 選択した参照はまだ保存されていません; レポートを再読み込みするとピッカーはリセットされます.',
    anchors: {
      sphereCd: {
        label: '球体 · C_D · Schiller–Naumann',
        citation:
          'Schiller & Naumann (1933). Über die grundlegenden Berechnungen bei der Schwerkraftaufbereitung. VDI, 77. 剛体の滑らかな球体で亜臨界 Re 域 (Re ≲ 3.5×10⁵) で有効。この閾値を超えると C_D が急落し、この相関式では追随できません。',
        qtyCd: 'C_D (抗力係数)',
      },
      thinAirfoilCl: {
        label: '薄翼 · C_L(α) · 2π 理論',
        citation:
          'Anderson, J. D. Fundamentals of Aerodynamics, 6th ed. 薄翼理論: 非粘性・非圧縮流中の対称薄翼で C_L = 2π·α. 各 DP の迎角から α を読み込み, Cl-vs-α スイープの参照線を生成. ±10% は NACA 24xx 程度のキャンバー寄与を吸収; 高キャンバー / 高揚力翼はこの帯域外です.',
        qtyCl: 'C_L (揚力係数)',
      },
      handCalcShapes: {
        citation:
          'サンドボックス手計算の形状ライブラリ (Hoerner, Fluid-Dynamic Drag; Anderson, Fundamentals of Aerodynamics; ESDU 空力データ; White, Fluid Mechanics). 教科書的な中程度の値; サニティチェック用途で, 出版レベルの検証目標ではありません.',
      },
      suddenExpansion: {
        label: '管拡大 · ζ · Borda-Carnot',
        citation:
          'Borda-Carnot 損失 (急激な断面積変化): ζ = (1 − A_in / A_out)². White, Fluid Mechanics, 第8版, §6.9. 直角段差の乱流に有効; 角度付きディフューザーや非円形ダクトは ±15% 帯域外.',
        qtyZeta: 'ζ (損失係数)',
      },
      pipeFrictionLaminar: {
        label: '管摩擦 · ζ · Poiseuille (層流)',
        citation:
          'Darcy-Weisbach と Hagen-Poiseuille 摩擦係数: f = 64 / Re, ζ = f · L / D_h. White, Fluid Mechanics, §6.4. 円形直管 Re < 2300 で有効; 遷移域と乱流域は Colebrook / Blasius (後続アンカー).',
        qtyZeta: 'ζ (損失係数)',
      },
    },
    shapeWarning: {
      generic:
        '本体が次と一致していると仮定しています: {{anchor}}. 偏差を引用する前に形状が実際に一致するか確認してください; 形状は記録に含まれず、間違ったリファレンスを選んでもエラーとしては表示されず、単に不適切な比較として現れます.',
    },
  },
  domainSchematic: {
    ariaLabel:
      '領域概略図; 中央に本体, 左に入口矢印, 右に出口コールアウト, 上下に遠方場ラベル.',
    figureLabel: 'ドメイン概略図',
    sectionHeading: '境界条件',
    caption: 'メッシュ化された領域と境界条件.',
    inletVelocity: '速度入口',
    inletVelocityInternal: '速度入口',
    uNotDeclared: 'U 未宣言',
    outletPressure: '圧力出口',
    pNotDeclared: 'p 未宣言',
    farfieldTop: '遠方場 (滑り壁)',
    farfieldBottom: '遠方場 (滑り壁)',
    wallLabel: '壁 (滑りなし) · コード長 {{chord}}',
    wallLabelInternal: '壁 (滑りなし)',
    nonWallPatchInternal: 'この面のすべてのパッチが壁とは限らない',
    arefDeclared:
      'A_ref 宣言値 {{value}} m². 暗黙前面投影面積 (コード長 × スパン) は mesh bbox × span が導線に載り次第表示; >100× のミスマッチは検証セクションの単位スケールチェックが検出する.',
    schematicCaveat: '非スケール・非幾何.',
  },
  assumptions: {
    heading: '仮定',
    intro:
      '数値が依拠する各仮定。↑ は仮定が報告値を押し上げ、↓ は無視または集約した影響が報告値を押し下げることを示す。○ は荷重経路により方向が変わるか、方向を決められないことを示し、省略が無害という意味ではない。',
    introPrefix: '数値が依拠する各仮定.',
    introInflating: 'インフレート (↑) = モデルが物理より大きく扱う.',
    introIgnoring:
      '無視 / 集約 (↓) = 省略した影響が報告値を下げると分かっている.',
    introNeutral:
      '○ = 荷重経路により方向が変わるか、方向を決められない。省略の影響がないという意味ではない.',
    direction: {
      up: 'インフレート; モデルが物理に対して過大に扱う',
      down: '無視または集約した影響が報告値を下げる',
      none: '荷重経路により方向が変わるか、方向を決められない',
    },
    steadyRans: {
      title: '定常 RANS, k-ω SST',
      body: '乱流はモデル化され, 解像はされません; 実流れの非定常性は監視量のスキャッターバンドとしてのみ現れます.',
    },
    incompressible: {
      title: '非圧縮',
      body: 'U = {{u}} m/s (M ≈ {{mach}}) では圧縮性効果は報告精度を大きく下回ります.',
      bodyNoU:
        '圧縮性効果は報告精度を大きく下回ると仮定; 風洞設定より速い流れの場合は入口速度で確認してください.',
    },
    fullyTurbulent: {
      title: '完全乱流境界層; 遷移モデルなし',
      body: '低レイノルズ数では実際の層は部分層流の可能性; 完全乱流としてモデル化すると, 物理流れに対して摩擦抗力を上方向に押します.',
    },
    fullyTurbulentInternal: {
      body: '部分層流の入口領域はモデル化されていません; 発達領域の報告圧力降下は物理値より高い可能性があります.',
    },
    smoothWall: {
      title: '水力学的に滑らかな表面',
      body: '粗さはモデル化されていません; 実表面では抗力を上方向に押すため, 報告 C_D は物理抗力より低くなります.',
    },
    smoothWallInternal: {
      body: '粗さはモデル化されていません; 実表面では圧力降下を上方向に押すため, 報告 Δp は物理値より低くなります.',
    },
    farfieldBlockage: {
      title: '遠方場はスリップ壁境界',
      body: 'ブロッケージ (本体の前面投影面積をトンネル断面積で割った比) は宣言された遠方場比で小さいが依然として拘束的で, 局所速度と揚力勾配を上方向に押します. 開発中: ブロッケージ比の行が検証セクションで正確な比率を表示予定.',
    },
    fluidProperties: {
      title: '流体は宣言された ρ と ν',
      body: 'すべての係数 (C_D, C_L, C_M) は q = ½ρU² で正規化されるため, 誤った ρ や U はそれぞれを比例的に再スケーリングします. 宣言値が正しいかどうかはレポートでは判定できません; 読者が選んだ値であることのみが確認できます.',
      bodyInternal:
        '報告される圧力降下 Δp は ρ に線形に比例し, 損失係数 ζ = 2·Δp / (ρU²) は ρ と U の両方に依存します. 誤った ρ や U は両方を比例的に再スケーリングします. 宣言値が正しいかどうかはレポートでは判定できません; 読者が選んだ値であることのみが確認できます.',
    },
    shapeAnalyst: {
      title: '断面形状は解析者の確認どおり',
      body: '手計算サンドボックスの参照はこの確認から選択されます; スタディ名からではありません.',
    },
    geometryTags: {
      title: '入口 / 出口タグは宣言どおり',
      body: 'レポートは "inlet" とタグ付けされたパッチを意図された入口として扱います; 誤ラベルの出口も質量収支を満たしますが, 誤ったポートを測定します. タグが意図と一致することは読者が確認します.',
    },
    feaStatic: {
      title: '静的・微小変位平衡',
      body: '荷重は慣性や時間履歴なしで適用され、変形後形状から剛性を更新しません。バックエンドに微小変位の妥当性しきい値はありません。剛体運動診断はモデル対角長の 10,000 倍（寸法不明時は 1,000,000 mm）を超える不可能な増分だけを拒否し、これは妥当性限界ではなく失敗検出です。',
    },
    feaEnergyEquilibrium: {
      title: '機械平衡のみ',
      body: '解析は外力と反力の釣り合いを解きます。温度場や熱エネルギー保存は解かないため、熱平衡またはエネルギー収支の判定はできません。',
      bodyWithPreload:
        '解析は外力と反力の釣り合いを解きます。熱収縮予荷重は規定した仮想温度差でひずみを作りますが、熱伝達、熱平衡、エネルギー保存は解きません。',
    },
    feaLinearElastic: {
      title: '線形弾性材料',
      body: '応力は材料ライブラリ値を用いてひずみに比例します。塑性、損傷、クリープ、温度依存特性はモデル化されません。',
    },
    feaMaterials: {
      title: '宣言された材料割り当て',
      bodyGlobal:
        'モデル全体に1種類の材料を適用し、すべてのボディを同じ弾性・密度特性で解釈します。',
      bodyByVolume:
        '{{materials}} 種類の材料を {{volumes}} 個のボリュームに割り当て、各ボリュームは固有の弾性・強度・密度特性を保持します。',
    },
    feaSupports: {
      title: '宣言された支持が剛体運動を拘束',
      body: '{{count}} 個の固定または軸選択支持をタグ付き面またはボディに適用します。治具自体のコンプライアンスは含みません。',
    },
    feaLoads: {
      title: '宣言された荷重セットのみ',
      bodyWithBodyForces:
        '{{loads}} 個の面・辺・圧力・結合荷重と、{{bodyForces}} 個の重力または遠心力ボディ荷重を含みます。',
      bodyWithoutBodyForces:
        '{{loads}} 個の面・辺・圧力・結合荷重を含みます。重力または遠心力ボディ荷重が未宣言のため、自重と回転効果は含みません。',
    },
    feaInitialState: {
      title: '初期応力状態',
      bodyNoPreload:
        'アセンブリは無応力状態から開始します。ボルト予荷重または焼きばめ予荷重ステージは未宣言です。',
      bodyWithPreload:
        '{{count}} 個のボルトまたは焼きばめ予荷重ステージで初期応力状態を作り、その後に使用荷重を適用します。',
    },
    feaContact: {
      title: '微小すべり接触',
      body: '{{count}} 組の宣言接触が微小すべり運動学で法線・接線トラクションを伝達します。バックエンドは各接触のすべり尺度を μ × 最大接触圧力 ÷ スティックスロープとして報告します。この尺度以下の運動は弾性固着の可能性があり、有限すべりと大回転はモデル化されません。',
    },
    feaCutbacks: {
      title: '非線形増分カットバック',
      bodyEnabled:
        '接触または予荷重ステップで自動カットバックが有効です。平衡が難しい場合、ソルバーは増分を縮小できます。',
      bodyDisabled:
        '自動カットバックは無効です。予定増分で平衡に達しない接触または予荷重ステップは、暗黙に小さい増分を使わず失敗します。',
    },
    feaModalEigenvalue: {
      title: '線形・非減衰固有値解析',
      body: '無応力構成から最初の {{count}} モードを抽出します。適用荷重、減衰、接触開口、予荷重剛性はこのモーダルモデルに含みません。',
    },
    thermalConduction: {
      steadyState: {
        title: '定常伝導',
        body: '時間に依存しない温度場を求めます。起動過渡やデューティサイクルはモデル化しません。',
      },
      singleMaterial: {
        title: '単一固体材料',
        body: '全ボリュームに熱材料ライブラリの {{material}} を適用します。',
      },
      declaredBcs: {
        title: '宣言された面条件',
        bodyNone:
          '明示的な熱 BC を持つ面はありません。未処理の面はすべて断熱です。',
        bodyWithInventory: 'タグ付き面: {{inventory}}。その他の面は断熱です。',
      },
      inventory: {
        fixedT: '固定温度 {{count}}',
        heatFlux: '熱流束 {{count}}',
        pointHeat: '節点熱荷重 {{count}}',
        convection: '対流 {{count}}',
        radiation: '放射 {{count}}',
        separator: '、',
      },
      adiabaticUntreated: {
        title: '未処理面は断熱',
        body: '条件を宣言していない面は法線方向の熱流束ゼロとなり、指定した面以外から熱は出ません。',
      },
      noThermalInterfaces: {
        title: 'ボディ間の熱インターフェースなし',
        body: 'このテンプレートではマルチボディアセンブリの共有界面は結合されません。各ボディは単一材料ドメインとして解きます。',
      },
      perfectContactSharedNodes: {
        title: '共有メッシュ接合部は完全熱接触',
        body: '接する面で節点を共有するため温度は連続し、接触抵抗ゼロで熱が渡ります（CHT の結合界面と同じ理想化）。実機の継手や界面層は抵抗を足すので、同じワットでは物理アセンブリの方が高温になります。',
      },
      perfectContactTies: {
        title: '結合タイは完全熱接触',
        body: '各結合タイは界面の温度自由度を等置し（CalculiX *TIE）、接触抵抗ゼロで熱が伝導します。実機の継手は 0.1 K/W 程度の抵抗を足すので、同じワットでは物理アセンブリの方が高温になります。',
      },
      steadyMaterialProps: {
        title: '定常解に密度と比熱は入らない',
        body: '定常状態では伝導率のみが温度場に影響します。ρ と c_p は過渡の立ち上がりを支配し、定常値ではありません。',
      },
    },
    chtSteadyEquilibrium: {
      title: '定常平衡',
      body: '起動時, ポンプ立ち上がり, 稼働サイクルは収束挙動としてのみ表れます; 結果は落ち着いた温度場であり, その到達時間については何も語りません.',
    },
    chtFrozenFluidProperties: {
      title: '流体物性は一温度で固定',
      body: 'ρ, μ, c_p, k は宣言条件でのライブラリ値です. 粘性は温度で変わるため, 大きな流体温度上昇のあるランは終端時点より濃い流体で解かれ, Δp が高めに読まれます. ΔT が数 K を超える場合は要確認.',
      bodyWithMaterial:
        '{{fluid}} の ρ, μ, c_p, k は宣言条件でのライブラリ値です. 粘性は温度で変わるため, 大きな流体温度上昇のあるランは終端時点より濃い流体で解かれ, Δp が高めに読まれます. ΔT が数 K を超える場合は要確認.',
      bodyWithMaterialAndDT:
        '{{fluid}} の ρ, μ, c_p, k は宣言条件でのライブラリ値です. 本ランでは流体温度上昇 {{dt}} K を計上 — 粘性は温度で変わるため, 濃いまま解いており Δp を高めに読みます. ΔT が数 K を超える場合は要確認.',
    },
    chtNoBuoyancy: {
      title: '浮力なし',
      body: '密度は固定であり, 重力設定に関わらず自然対流の熱輸送寄与はゼロです. Gr / Re² ≪ 1 で有効; 低流量または無流量のシナリオではこのモデルで唯一残る熱経路が失われます.',
    },
    chtPerfectThermalContact: {
      title: '接合部で完全熱接触',
      body: '連成温度界面は接触抵抗ゼロです; 実際の界面層や機械的接合部は 0.1 K/W オーダーの抵抗を追加するため, 同じワット数で実機はこのモデルより高温になります. モデルと実機計測の最大の差になることが多いです.',
    },
    chtUniformHeatSource: {
      title: '発熱源体積内で均一分布',
      body: '宣言された熱流量は発熱領域全体に均等に分布します; 発熱源内の局所ホットスポットは報告される領域最高温度を上回ります.',
      bodyWithQ:
        '宣言された {{q}} は発熱領域全体に均等に分布します; 発熱源内の局所ホットスポットは報告される領域最高温度を上回ります.',
    },
    chtAdiabaticExternalWalls: {
      title: '外壁は断熱',
      body: '外表面からの自然冷却はゼロで, すべてのワットが流体を通じて排出されます. 実機では周囲へも熱を逃がすため, 報告温度は実機を上回ります. 熱マージンには保守的.',
    },
    chtNoRadiation: {
      title: '放射なし',
      body: 'この温度域では数 % 程度で, T⁴ で増加します; 受動冷却や空冷構成では再検討.',
    },
    chtTurbulenceModel: {
      title: '乱流モデル (k-ω SST), 熱は一定の乱流 Prandtl 数で橋渡し',
      body: 'h は壁面処理の質を継承します: 壁面間隔チェックが対流側の信頼性を左右します. 層流ランではこの行は "Re が層流範囲にあることを確認" に置き換わります.',
      bodyWithModel:
        '乱流モデル ({{model}}), 熱は一定の乱流 Prandtl 数で橋渡し. h は壁面処理の質を継承します: 壁面間隔チェックが対流側の信頼性を左右します.',
      titleLaminar: '層流を想定',
      bodyLaminar:
        '乱流クロージャなし; 運動量と熱の境界層を直接解きます. この流路で Re が層流範囲にあることを確認してください — 遷移域のケースでは h が低めに読まれます.',
    },
    chtUniformInlet: {
      title: '均一入口: 一温度, 一速度',
      body: 'ポート上流のマニホールド分配ムラは入口条件誤差として現れ, 発達長さの脚注につながります.',
      bodyWithT:
        '入口は一温度 ({{t}} °C) と一速度. ポート上流のマニホールド分配ムラは入口条件誤差として現れ, 発達長さの脚注につながります.',
      bodyWithTAndU:
        '入口は一温度 ({{t}} °C) と一速度 ({{u}} m/s). ポート上流のマニホールド分配ムラは入口条件誤差として現れ, 発達長さの脚注につながります.',
    },
    chtAdiabaticExterior: {
      title: '外表面は断熱として扱われます',
      body: 'いずれの面にも熱境界条件が指定されていないため、領域界面以外のすべての面は熱を逃がしません。実際の組立体は周囲へも放熱するので、固体温度は高めに出ます。また外部への経路がないため、定常状態では界面が宣言熱流量とちょうど同じ熱量を運ぶ必要があります。',
    },
    chtDeclaredExterior: {
      title: '外表面に境界条件が指定されています',
      body: '{{count}} 個のタグ付き面に温度・熱伝達率・熱流束が指定されています。熱が冷却材を通らずに系外へ出られるため、界面合計が宣言熱流量と一致する必要はありません。',
    },
    chtSolverSafetyLimits: {
      title: 'ソルバー安全リミット armed',
      body: 'ふれられなかったリミットは不可視です; 大量のクランプは解がソルバーによって境界内に保持されたことを意味します. クランプチェックがどれだけクランプが実際に適用されたかを評価します.',
      bodyWithLimits:
        '温度を [{{tMin}}, {{tMax}}] °C にクランプ; 速度を約 {{uMax}} m/s にクランプ. ふれられなかったリミットは不可視で, 強いクランプは解がソルバーで境界内に保持されたことを意味します.',
    },
  },
  chtHeadline: {
    peakNamed: '{{region}} の最高温度: {{tmax}}。',
    peakUnnamed: '固体の最高温度 {{tmax}}。',
    withinNamed: '{{region}} の最高温度: {{tmax}} — 上限 {{limit}} 以内。',
    withinUnnamed: '固体の最高温度 {{tmax}} — 上限 {{limit}} 以内。',
    exceedsNamed: '{{region}} の最高温度: {{tmax}} — 上限 {{limit}} を超過。',
    exceedsUnnamed: '固体の最高温度 {{tmax}} — 上限 {{limit}} を超過。',
  },
  regionGraph: {
    heading: '領域グラフ',
    intro:
      'このランがモデル化するすべての熱経路を描画します。Q̇ は発熱源固体 (左端) に流入します。グレー矢印は固体-固体の伝導、青矢印は冷媒への対流。矢印のラベルは定常状態で界面を横切る「正味の総ワット数」— ランを積分した速度で, ピーク値でも平均値でもありません。符号はここでは絶対値化しており, 方向は矢印そのものが示します。ピーク熱流束 (W/m²) は概要カードに表示され, 矢印上ではありません。',
    parallelFlowNote:
      '固体ボックスは最も強い隣接辺の順に左から右へ並びます。一つの固体が複数の固体と界面を持つ場合、主鎖の辺のみを描画します; その他の辺もボックス内の合計値には寄与しています。界面ごとの完全な内訳は DP 詳細結果行にあります。',
    stateToggleAria: '宣言入力と求解出力の切り替え',
    stateDeclared: '宣言値',
    stateSolved: '求解値',
    stateDeclaredHint:
      '設定で要求された値を表示 — 入口温度、Q̇、目標 T。ボックス内の温度は BC を読みます。',
    stateSolvedHint:
      '求解が返した値を表示 — 定常状態の領域 T、界面熱流束、冷媒 ΔT。',
    ambientLabel: '外環境 · 断熱 (熱流出なし)',
    ambientLabelDeclared: '周囲 · 外表面に境界条件あり',
    sourceMarker: '発熱源',
    fluidRangeMissing: 'サマリに温度範囲なし',
    hottest: '本ランで最高温度の固体。',
    hottestBadge: '最高温',
    regionRoleSolid: '固体',
    regionRoleFluid: '流体',
    tooltipHeatSource: '宣言発熱源',
    tooltipHeatSourceUnknown: '宣言発熱源: 総熱流量がデータ上にありません。',
    tooltipConvection: '冷媒への対流',
    tooltipConvectionUnknown:
      '対流ワット数はまだデータ上にありません (古いラン)。この面は断熱ではありません。この固体と冷媒の間には実際の温度勾配があり熱は流れていますが, 数値がこのランには記録されていないだけです。',
    tooltipConduction: '隣接固体への伝導',
    tooltipConductionUnknown:
      '伝導ワット数はまだデータ上にありません (古いラン)。この界面は断熱ではありません。隣接する固体は面を共有し温度勾配があるため熱は流れていますが, 数値がこのランには記録されていないだけです。',
    tooltipSignHint:
      '(符号: + = 熱がこの固体から冷媒へ; − = 冷媒がこの固体を加熱)',
    tooltipCoolantIn: '入口',
    tooltipCoolantOut: '出口',
    tooltipCoolantDelta:
      '冷媒 ΔT。絶対値で表示し, 符号規則はテンプレートで異なります。',
  },
  deltaTable: {
    baselineLabel: '基準:',
    dp: 'DP',
    needsMultipleDps:
      'デルタテーブルには少なくとも 2 つの完了設計点が必要です; 1 つの DP との比較は自己参照かゼロです.',
    caption_one:
      '{{count}} 個 DP 比較 · セルは絶対 Δ (パーセント Δ) を基準と対比',
    caption_other:
      '{{count}} 個 DP 比較 · セルは絶対 Δ (パーセント Δ) を基準と対比',
  },
  dpTable: {
    dp: 'DP',
    verdict: '判定',
    empty: '結果サマリーを持つ完了設計点はまだありません。',
    caption_one:
      '{{count}} 個の設計点 · ヘッダーをクリックしてソート · 判定は実行状態、収束、質量収支から',
    caption_other:
      '{{count}} 個の設計点 · ヘッダーをクリックしてソート · 判定は実行状態、収束、質量収支から',
    verdicts: {
      pass: '合格',
      warn: '要確認',
      fail: '不合格',
      stopped: '停止',
      notEvaluated: '未評価',
    },
    verdictReasons: {
      stopped:
        '{{iters}} 回反復後、収束を確認する前に実行が停止しました。保存された値は途中結果であり、発散の判定ではありません。',
      pass: 'ソルバー収束済み, 質量収支は 1 % 以内.',
      fail: 'ソルバーが収束しませんでした。最悪残差 {{eq}} = {{value}} は目標 {{target}} に対して {{factor}} 倍で、{{iters}} 回反復後の値です。',
      failNoTarget:
        'ソルバーが収束しませんでした。{{iters}} 回反復後の最悪残差は {{eq}} = {{value}} です。この実行は残差目標を持たないため、基準からどれだけ離れているかはワイヤ上にありません。',
      failSplitTarget:
        'ソルバーが収束しませんでした。{{iters}} 回反復後の残差は {{eq}} = {{value}} です。流体領域と固体領域で目標値が異なり、実行は両領域に対して 1 つの残差しか報告しないため、どちらの目標とも比較しません。',
      failNoResiduals:
        'ソルバーが収束せず、方程式ごとの残差も報告されていないため、判明しているのは反復回数 {{iters}} のみです。',
      warn: 'ソルバーは収束しましたが、質量不均衡が {{pct}} % で、{{bar}} % の基準に対して {{factor}} 倍です。領域が完全に閉じていません。',
      notEvaluated:
        '判定に十分な信号がありません; 収束または質量収支フィールドが出力されていません.',
      noSignals:
        'この設計点にはまだ結果サマリーがありません; 実行完了後に判定が入力されます.',
    },
  },
  verification: {
    evidence: {
      wallBufferFails:
        '壁面積の {{frac}}% が y⁺ 5–30 の緩衝帯にあり、どちらの壁面処理も妥当ではありません（上限 {{limit}}%）— この実行の摩擦値は採用できません',
      wallBufferPassesCaveat:
        '壁面積の {{frac}}% が y⁺ 5–30 の緩衝帯にあります — 許容範囲ですが、摩擦の主張にはこの留保が付きます',
      wallBufferPasses: '壁面積の {{frac}}% が y⁺ 5–30 の緩衝帯にあります',
      flowTypeMismatch:
        '{{template}} テンプレートが {{mesh}} メッシュ上で実行されています — 正しく解けていても問題設定が違うままです',
      stagnationFails:
        '壁面ピーク圧力が動圧の {{ratio}} 倍（期待値 {{expected}}）— 圧力場と宣言した流動条件が一致しません',
      stagnationPasses:
        '壁面ピーク圧力は動圧の {{ratio}} 倍で、期待値 {{expected}} の {{tol}}% 以内です',
      energyImbalanceFailsWithFlows:
        'エネルギー不均衡 {{imbalance}} J が許容帯 {{tolerance}} J を超えています。許容帯は最大エネルギー項のおおよそ 1% で、推定（復元勾配）熱流を使う面の割合が {{fraction}} のとき広げられ、さらに {{absTol}} W × {{period}} s の小さな下限が加わります。面熱流は時間で積分され、推定値は残差を広げ得ます——それは保存則の破れではなく、それらの面付近のメッシュ分解能の問題です。（投入エネルギー {{energyIn}} J、蓄熱変化 {{deltaE}} J）',
      energyImbalanceFails:
        'エネルギー不均衡 {{imbalance}} J が許容帯 {{tolerance}} J を超えています。許容帯は最大エネルギー項のおおよそ 1% で、推定（復元勾配）熱流を使う面の割合が {{fraction}} のとき広げられ、さらに {{absTol}} W × {{period}} s の小さな下限が加わります。面熱流は時間で積分され、推定値は残差を広げ得ます——それは保存則の破れではなく、それらの面付近のメッシュ分解能の問題です。',
      energyImbalancePassesWithFlows:
        '境界熱と蓄熱変化は {{tolerance}} J 以内で閉じます。面熱流は可能なとき直接測定（反力・付与フラックス・膜温度）を時間積分し、推定の復元勾配熱流は最後の手段です。（投入エネルギー {{energyIn}} J、蓄熱変化 {{deltaE}} J）',
      energyImbalancePasses:
        '境界熱と蓄熱変化は {{tolerance}} J 以内で閉じます。面熱流は可能なとき直接測定（反力・付与フラックス・膜温度）を時間積分し、推定の復元勾配熱流は最後の手段です。',
      energyImbalanceUnavailable:
        'この過渡解析は積分エネルギー収支を作成していないため、閉合は測定されていません。',
      temperatureBoundsFails:
        '温度が初期条件と境界／環境値の [{{lo}}, {{hi}}] K 帯を外れました（観測 [{{obsMin}}, {{obsMax}}] K、許容 {{tol}} K）。第1増分を大きくするか、段差境界付近のメッシュを細かくしてください。',
      temperatureBoundsPasses:
        'すべての温度が [{{lo}}, {{hi}}] K 内に留まりました（±{{tol}} K の出力ノイズ）。',
      boundaryFluxUnresolved:
        '二つの境界面積分が {{imbalance}} W 異なり、許容帯 {{tolerance}} W を超えています（入力 {{heatIn}} W、出力 {{heatOut}} W）。メッシュが一つ以上の BC 面の温度勾配を分解できず、そこから読む面熱流は信頼できません。それらの熱流を使う前に BC 面の境界層を細かく再メッシュしてください。温度と求解自体は影響を受けません——定常伝導は構成上エネルギーを保存します。',
    },
    cht: {
      coolantMassBalance: '冷却材の質量保存',
      coolantMassBalanceSub:
        '冷却材領域の通過流量 {{flow}} kg/s に対して {{imbalance}} kg/s。',
      energyClosure: 'エネルギーの不均衡',
      energySub: '入力 {{in}} W、除去 {{out}} W。',
      heatIn: '流入 {{value}} W',
      heatOut: '流出 {{value}} W',
      // 収支が閉じない原因のうち、実行側の問題とは言えないもの。BE は英文で
      // 送ってくるため、翻訳セッションではこちらを表示する。
      explained: {
        notConverged:
          '収束は確認されていません。この途中段階の収支だけでは発散とは判断できません',
        limiterClamped:
          'リミッターがセルをクランプしており、場は書き換えられるが場から計算される流束は書き換えられないため、高めに出ることが想定される',
      },
      energyExplainedBy: '解釈には注意が必要です：{{reasons}}。',
      temperatureTarget: '温度目標',
      targetSub: '宣言された上限 {{limit}} K。',
      interfaceFlux: '冷媒への熱量',
      interfaceFluxSub: 'ピーク {{peak}} W/m²（{{patch}}）。',
      balance: {
        success: '成立',
        warning: '緩い',
        destructive: '不成立',
      },
      energy: {
        ok: '成立',
        warn: '緩い',
        fail: '不成立',
        provisional: '途中結果',
      },
      target: { met: '達成', missed: '未達', notRequested: '未宣言' },
      tooltips: {
        coolantMassBalance:
          '流出と流入の差を通過流量に対する割合で表したもの。実行は絶対値 kg/s を報告しますが、CFD の質量不平衡と同じ基準で読めるように割合で示しています。数パーセントを超えると質量が保存されておらず、以降の数値は信頼できません。',
        energyClosure:
          'モデル全体の検査領域を出入りする熱の移動率（W）です。蓄えられたエネルギー量ではありません。不均衡 = 100 ×（入熱 − 排熱）/ 入熱。0% は一致、+100% は排熱の報告なしです。内部の固体・流体間の熱移動は外部への排熱に含めません。未収束の実行では収支が合わない場合があります。',
        energyProvisional:
          '最終解の前に実行が停止しました。排熱率の欠落は出力が途中段階であるためかもしれません。この割合だけでは熱の蓄積や数値発散は判断できません。',
        heatIn:
          '固体熱源など、モデル内に宣言した発熱率です。単位は W で、蓄えられたエネルギー量ではありません。',
        heatOut:
          '外部境界を通ってモデルから出ると報告された熱の移動率です。領域間の内部移動は含めません。単位は W です。',
        temperatureTarget:
          '最高温部の固体が宣言された上限を下回ったか。2 値ではなく 3 値です — 上限が未宣言であることは合格ではなく、検証されていない余裕度を表示せずそう明示します。',
        interfaceFlux:
          '固体が流体-固体界面を通じて冷媒に渡す正味の熱量 (負: 冷媒が固体を加熱) と、最大の熱流束密度をもつパッチ。上のエネルギー収支の片側なので、ゲートではなく参照値です。',
      },
    },
    heading: '検証',
    subhead: '設計点ごとの収束、質量収支、乱流、および力の分解シグナル。',
    noneAvailable:
      'まだ完了した設計点がありません; 少なくとも 1 回の実行が完了すると、検証シグナルが表示されます。',
    designPoint: 'DP {{id}}',
    notEvaluated: '未評価',
    convergence: '収束',
    converged: '収束',
    convergedAtIterationLimit: '収束（発散なし）、反復上限に到達',
    notConverged: '未収束',
    itersLabel: '({{used}}{{max}} 反復)',
    exitReasonLabel: '停止した理由',
    exitReason: {
      converged: 'すべての方程式が目標に到達',
      iterationLimit: '反復上限に到達',
      timeLimit: '時間切れ',
    },
    stopLimit: {
      iterationLimit: '停止：反復上限に到達',
      timeLimit: '停止：時間制限に到達',
    },
    exitReasonTimeSub:
      'この実行を止めたのは残差ではなく時間制限です。これだけでは設定の問題を示しません。',
    regionFluid: '流体',
    regionSolid: '固体',
    regionTargetsNote:
      '{{equations}} の目標値は流体領域と固体領域で異なります。実行は両領域に対して 1 つの残差しか報告しないため、どちらの目標とも比較しません。',
    hitIterLimit: '反復上限に到達',
    silentPassSuspect: '目標到達後も反復上限まで実行',
    terminatingCriterion: '終了基準',
    cumulativeContinuity: '累積連続式誤差',
    massImbalance: '質量不平衡',
    percentile: 'パーセンタイル',
    residualsHeading: '残差',
    residualImbalanceRelation: {
      title: 'この不均衡の求め方',
      stepLabel: 'ステップ {{position}}／{{total}}',
      energyHeading: 'エネルギー不均衡（境界熱流束から）',
      energyEquationAria: 'ε_E は 100 × (Q_in − Q_out) / Q_in に等しい',
      energyPluggedAria:
        '{{pct}} パーセントは 100 × ({{in}} − {{out}}) / {{in}} ワット',
      energyScopeNote: 'Q_in と Q_out はモデル全体の外部境界熱流束の合計です。',
      varQinMeaning: '外部境界から入る熱',
      varQoutMeaning: '外部境界から出る熱',
      varEpsilonEMeaning: 'その合計から求めたエネルギー不均衡',
      interfaceNotInFormula:
        '界面を通じて冷媒が受け取る熱量（{{value}} W）は別途表示します。ε_E は Q_in と Q_out だけを使います。',
      massHeading: '質量不均衡（冷却材スループットから）',
      massHeadingFlow: '質量不均衡（入口・出口の流量から）',
      massStepImbalanceAria: 'ṁ_imbalance は ṁ_in + ṁ_out に等しい',
      massStepImbalanceNote:
        '冷却材の入口・出口での有符号質量流量の合計。流入は負、流出は正；その和が境界での正味の質量不均衡です。',
      massStepImbalanceNoteFlow:
        '入口と出口での有符号質量流量の合計。流入は負、流出は正；その和が正味の質量不均衡です。',
      massStepRefAria: 'ṁ_ref は |ṁ_in| と |ṁ_out| の大きい方に等しい',
      massStepRefNote:
        '基準流量は入口と出口の流量の絶対値の大きい方です。出口がまったく流量を報告しない場合、不均衡は未定義ではなく 100% です。',
      massEquationAria: 'ε_m は |ṁ_imbalance| / ṁ_ref に等しい',
      massStepFracNote:
        '相対不均衡：境界での正味流量を、入口と出口の流量の大きい方に対する割合で表します。残差からではなく境界の流量から求めます。',
      massPluggedAria:
        '{{pct}} パーセントは |{{imbalance}}| / {{flow}} キログラム毎秒',
      massPluggedFrac: '大きい方の流量の {{pct}} %',
      massScopeNote:
        'ṁ_imbalance と ṁ_ref は流体領域の冷却材入口と出口から取ります。',
      massScopeNoteFlow:
        'ṁ_imbalance と ṁ_ref は流れ領域の入口と出口の開口部から取ります。',
      varMInMeaning: '入口の冷却材質量流量（流入は負）',
      varMOutMeaning: '出口の冷却材質量流量（流出は正）',
      varMImbalanceMeaning: '冷却材の正味質量不均衡（ṁ_in + ṁ_out）',
      varMRefMeaning:
        '冷却材の入口・出口質量流量の大きい方（max(|ṁ_in|, |ṁ_out|)）',
      varEpsilonMMeaning: '大きい方の流量に対する質量不均衡の割合',
      linkHeading: '最終反復の残差：別の指標',
      linkNote:
        '残差はセルごとに解がどれだけ落ち着いたかを示します。上の不均衡は残差からではなく境界での流量から求めるため、不均衡がほぼゼロでも残差が目標を上回ることはよくあります。両者は別々に読んでください。',
      askAssistantAgent: 'Agent',
      askAssistant: 'この実行で残差 (h) と ε_E がどう関係するか聞く',
      askAssistantLabel:
        'この実行で残差 (h) とこのエネルギー不均衡がどう関係するかアシスタントに聞く',
      askAssistantTitle: 'ε_E と残差 (h)',
      askAssistantNoTarget: '記録なし',
      askAssistantPrompt:
        'この設計点では residual(h) が {{residual}}（収束終了目標 {{target}}）。入熱は {{qin}} W、出熱は {{qout}} W なので ε_E は {{pct}} % です。残差はエネルギー解がどれだけ落ち着いたかを示し、ε_E は残差ではなく境界の熱の合計から求めます。この実行で両者はどう関係し、どちらかが結果を疑う理由になりますか？両者が一致するはずだとは仮定しないでください。平易な言葉で答えてください。ツール名や配線フィールドのパスは使わないでください。\n\nツール用の文脈のみ — 私には繰り返さないでください: スタディ {{studyId}}、設計点 {{dpId}}。',
      linkEnergyLabel: 'エネルギー',
      linkMassLabel: '質量／連続',
      linkResidualVsTarget: '残差 {{residual}}、収束終了目標 {{target}}',
      linkResidualNoTarget: '残差 {{residual}}、収束終了目標の記録なし',
    },
    relaxation: '緩和係数',
    relaxationTooltip:
      '実行時の緩和係数（0～1）。小さいほど慎重に更新します。— は設定が報告されていないことを示します。',
    residualTooltips: {
      U: '速度の方程式です。',
      p: '圧力の方程式です。',
      p_rgh: '重力補正後の圧力。質量流量の整合に使います。',
      h: '流体または固体のエネルギー方程式です。',
      T: '温度の方程式です。',
      k: '乱流運動エネルギーの方程式です。',
      omega: '乱流の比散逸率の方程式です。',
      epsilon: '乱流の散逸率の方程式です。',
      other: '{{equation}} 方程式の残差です。',
    },
    equation: '方程式',
    final: '最終',
    residual: '初期残差',
    target: '目標',
    overTarget: '目標超過',
    noResiduals: '残差データなし。',
    boundingHeading: '境界クリッピング',
    field: 'フィールド',
    count: '回数',
    firstIter: '初回反復',
    maxMagnitude: '最大振幅',
    forcesHeading: '力; 圧力 / 粘性の内訳',
    forcesCaption:
      '圧力 = 法線トラクション（形状抗力の主因）。粘性 = 接線トラクション（摩擦抵抗）。この 2 つを合計しないでください; 合計が一致していても、大きく相殺する 2 つの誤差が隠れている場合があります。',
    axis: '軸',
    pressureN: '圧力 ({{unit}})',
    viscousN: '粘性 ({{unit}})',
    coefficientsHeading: '力係数',
    lOverD: 'L / D',
    copFracLref: 'CoP 位置 (l_ref)',
    copSuppressed: '抑制 (|C_L| < 1e-3)',
    refGeometry: 'A_ref = {{area}} · l_ref = {{chord}}',
    yPlusHeading: '壁面 y⁺',
    yPlusMin: '最小',
    yPlusMean: '平均',
    yPlusMax: '最大',
    yPlusFracBelow5: 'y+ <5 の面積比',
    yPlusFrac5To30: 'y+ 5–30 の面積比',
    yPlusFrac30To100: 'y+ 30–100 の面積比',
    yPlusFracAbove100: 'y+ >100 の面積比',
    yPlusBandsPending:
      '面積比バンド（<5 / 5–30 / 30–100 / >100）は 開発中; 最小/平均/最大だけでは境界層のカバレッジを見落とす可能性があります。',
    externalDomainHeading: '領域とブロッケージ',
    blockageRatio: 'ブロッケージ比',
    domainExtentsX: 'X 方向広がり（本体径倍）',
    domainExtentsY: 'Y 方向広がり（本体径倍）',
    domainExtentsZ: 'Z 方向広がり（本体径倍）',
    externalDomainPending:
      'ブロッケージ比と軸別広がりは 開発中; 一般的な 0.55% から 2.18% への上昇が現在どこにも現れません。',
    freestreamHeading: '自由流の乱流',
    freestreamNutOverNu: 'ν_t / ν（自由流）',
    turbulenceIntensity: '乱流強度',
    turbulentLengthScale: '乱流長さスケール',
    freestreamPending:
      '入口の派生 ν_t / ν は 開発中; 強度と長さスケールは宣言されるが比率が計算されないため、5 500× が現実的な 10 として通過する可能性があります。',
    tooltips: {
      convergence:
        'ソルバーが反復予算内で残差制御に到達したかどうか。「未収束」は反復予算切れの実行を示します; 以下の数値は依然としてソルバーの出力ですが、収束していない場を見ていることになります。',
      terminatingCriterion:
        'ソルバーが反復を停止した理由; 残差制御達成、反復予算切れ、またはソルバー側の中止。',
      exitReason:
        '定常計算の停止理由は 3 つです: すべての方程式が目標に到達する、反復上限に到達する、時間切れになる。収束とみなされるのは最初のものだけです。',
      cumulativeContinuity:
        '実行全体で累積した質量フラックスの不均衡。定常解では 0 に減衰するはずです。単調増加は圧力場が偽の質量源として作用していることを意味します。スパークラインは軌跡を示し、平坦/減衰と増大を一目で区別できます。',
      massImbalance:
        '流入流量のうち出口から出なかった（または逆流した）割合。外部流では境界条件の不整合で非ゼロとなり得ますが、内部流で ~1% を超える場合は回路が閉じていない兆候です。',
      nutRatio:
        '領域全体の乱流粘性比（ν_t / ν）のパーセンタイル。P50 が 1 未満なら乱流モデルはほとんど寄与していません; SST と表示された層流解です。対数則領域では ~10 から数百が目安。',
      cd: '無次元抗力係数; 流れ方向の全力を ½ρV²A_ref で割ったもの。符号は流れに沿う方向を正とします。',
      cl: '無次元揚力係数; 横流れ方向の全力を ½ρV²A_ref で割ったもの。',
      cmPitch:
        '基準点まわりのピッチングモーメント係数（翼型では通常 1/4 弦長点）。符号は study 設定に従います。',
      lOverD: '揚抗比、C_L / C_D。大きいほど効率的です。',
      copFracLref:
        'l_ref に沿った圧力中心位置、C_M,pitch / C_L として計算。|C_L| がゼロ近傍では意味を失うため、1e-3 未満ではパネルが抑制します; もっともらしいノイズを表示しないためです。',
      yPlusMin:
        '物体表面の壁 y⁺ 最小値。5 未満は粘性底層に相当し、壁関数は成立しません。対数則外挿によるせん断応力・熱流束は信頼できません。',
      yPlusMean:
        '面積加重平均の壁 y⁺。有用な指標ですが、壁の大部分が粘性底層にあるか外側対数則領域にあるかを見落とします。',
      yPlusMax:
        '壁 y⁺ 最大値。~300 を超えると対数則の有効範囲外で、壁付近のメッシュがせん断応力を正しく解像するには粗すぎます。',
      pressureDrop:
        '領域を横断する物理的圧力降下 p_in − p_out（Pa）。駆動入口チャネルでは正、負は圧力上昇（管拡大、ディフューザー、または境界条件反転）を意味します。',
      pressureDropKinematic:
        '運動学的圧力降下（m²/s²）;ソルバー内部で扱う値、すなわち Δp / ρ。ρ を掛けて物理 Pa を得ます。',
      inletFlowRate:
        '入口の体積流量（m³/s）。BE 規約：入口は負（流れが外向き面法線に逆らって入る）、出口は正; |Q_in| = |Q_out| の一致は質量収支チェック。',
      outletFlowRate:
        '出口の体積流量（m³/s）、駆動入口チャネルでは正。|Q_in| と比較して質量収支をチェック。',
      portVelocity:
        '入口/出口パッチを通る面積加重平均速度（m/s）。定密度解で両者が乖離する場合、質量不均衡またはポート面積の不一致を示します。',
      wallPressureRange:
        '壁圧力の極値（Pa）;偽のソースや BC 側の不具合の安価な健全性チェック。範囲を ρU²/2 と比較すると、壁が妥当な仕事をしているか判断できます。',
      yPlusFracBelow5:
        '粘性底層（y+ < 5）に属する壁面積の割合。壁関数は成立しないため、大きな割合は対数則外挿によるせん断応力・熱流束が信頼できないことを意味します。',
      yPlusFrac5To30:
        'バッファ層（y+ 5–30）の壁面積比。粘性底層でも対数則でもない中間領域で結果が予測しにくいため、この割合は小さいことが望ましい。',
      yPlusFrac30To100:
        '対数則領域（y+ 30–100）の壁面積比。壁関数型乱流モデルが本来想定する範囲。大きいほど良い。',
      yPlusFracAbove100:
        '対数則有効範囲を超える（y+ > 100）壁面積比。壁付近のメッシュが粗く、せん断応力が信頼できない。',
      blockageRatio:
        '本体前面投影面積を同じ位置の外囲断面積で割った値。~5% を超えると閉塞効果で本体まわりの流れが変わり、自由流基準との比較が公正でなくなります。',
      domainExtents:
        '本体から外側境界までの広がりを本体径単位で表したもの。外囲設定と本体バウンディングボックスから読者が導出する必要をなくす「十分に遠い」の指標。',
      freestreamNutOverNu:
        '入口での派生乱流粘性比、宣言された乱流強度と長さスケールから計算。航空系のトンネル現実値は 10 前後、内部流では数百まで、1 000 を超えると入口が既に完全乱流化しています。',
      turbulenceIntensity:
        '入口境界条件で宣言する乱流強度。航空系トンネルで 0.1–1%、産業流では 5–10%。これは入力であり測定値ではありません; 派生 ν_t / ν を追跡するために保持しています。',
      turbulentLengthScale:
        '入口境界条件で宣言する乱流長さスケール; 典型的には水力直径や本体代表寸法の一部。派生 ν_t / ν を追跡するために保持。',
      portArea:
        '入口/出口面の断面積（m²）。設計意図と照合すると、4× のポート面積不一致が「解が壊れた」ではなく「予想外の質量収支」として現れます。',
      reversedFlowFrac:
        '流れが領域内に入ってくる（バックフロー）出口面の面積比。面積加重出口速度は符号相殺でバックフローを隠すため、面別のフラックス符号分解が正しい指標です。',
      stagnantVolumeFrac:
        '|U| が一定閾値未満のセル体積比。高値（HX の例で 92%）は作動流体が形状の大部分に届いていないことを意味します; 何も仕事をせずに「成功」した実行。',
      deadEndVolumeFrac:
        '流路がない（袋小路の）領域体積比。流れそのものではなくメッシュ接続から計算するため、発散した実行でも有効です。',
      disconnectedVolumeFrac:
        '入口にも出口にも一切つながっていないメッシュ体積比。流れが決して到達できない流体で、多くは部品の形状ではなくメッシャーが閉じ込めた空隙です。メッシュのみから読み取るため、発散した実行でも有効です。流れが入れる袋小路はここには含まれません（袋小路の行を参照）。',
      hydraulicDiameter:
        '入口の水力直径 D_h = 4·A/P。A は流れ面積、P は接液周長。あらゆる内部流レイノルズ数の基礎となる長さスケールを追跡可能な形で提示。',
      reynolds:
        '入口でのレイノルズ数 Re = ρ U D_h / μ、導出値。現在は BE から出力されない; 入口条件を追跡可能にするため、入口境界条件と共に配置すべき値。',
    },
    internalFlowHeading: '内部流シグナル',
    pressureDropKinematic: 'Δp / ρ',
    wallPressureRange: '壁圧力（最小 / 最大）',
    reversedFlowFrac: '出口別バックフロー比',
    stagnantVolumeFrac: '停滞体積比',
    deadEndVolumeFrac: '袋小路体積比',
    disconnectedVolumeFrac: '孤立体積比',
    reynolds: 'レイノルズ数',
    internalFlowExtendedPending:
      '袋小路体積（流れは入れるが通り抜けられない行き止まり）は開発中です。この行が空でも「袋小路なし」ではありません。',
  },
  handCalc: {
    scopes: {
      sectionHeading: '領域ごと',
      unavailableCount: 'ここでは {{count}} 件が利用不可',
      noneValid:
        'この実行が計算する関係式に、このスコープへ適用できるものはありません。',
      runReports: '実行の報告値',
      waitingOn: '未入力',
      facts: {
        declaredPower: '宣言値',
        interfacePower: '界面通過',
        massFlow: 'ṁ',
        coolantRise: 'ΔT',
        pressureDrop: 'Δp',
        patchFlux: '熱流',
        wettedArea: 'A_wet',
        volume: '体積',
        peakTemperature: 'T 最大',
        patchSum: 'パッチ合計',
        peakFlux: '最大熱流束',
        patchGap: '内訳差',
        fluxDensity: 'Q̇/A_wet',
        shareOfTotal: '報告総量比',
        spread: '内部温度差',
        interfaceDeltaT: 'ΔT（領域平均）',
        overallCoefficient: 'K = Q̇/(A·ΔT)',
        meanTemperature: 'T 平均',
        peakVelocity: 'U 最大',
        resistance: 'R',
        closure: '収支差',
      },
      resolvedFrom:
        '{{region}} 領域から解決（材料 {{material}}）。上の仮定列はケース全体の値で、このスコープは自身の値を読みます。',
      energyFlow: '熱の経路',
      reversedPatches_one:
        '{{count}} 件の界面は逆方向（固体側へ）に熱を運んでいます。',
      reversedPatches_other:
        '{{count}} 件の界面が逆方向（固体側へ）に熱を運んでいます。',
      conductionUnavailable:
        'この実行には固体間の熱伝導が含まれていません。固体同士の接触はすべて未計測のため、冷却材にのみ接する固体はその 1 本の帯だけで描かれます。',
      nodeTemperatures: 'T 最小 / 平均 / 最大',
      tempStops: { min: '最小', avg: '平均', max: '最大' },
      nodeIn: '流入',
      nodeOut: '流出',
      kMissing: {
        noArea: 'K には濡れ面積が必要ですが、この実行では報告されていません',
        noGradient: 'K には温度勾配が必要です — 両側が同じ温度です',
      },
      railLabel: '手計算のスコープ',
      heading: 'スコープ',
      filed: '{{count}} 件登録',
      wholeModel: 'モデル全体',
      noScopes: 'この実行には手計算を登録できるスコープがありません。',
      kinds: {
        case: 'ケース',
        fluid: '流体',
        solid: '固体',
        iface: '界面',
      },
      kindPlural: {
        case: 'ケース',
        fluid: '流体領域',
        solid: '固体領域',
        iface: '界面',
      },
      kindWords: {
        case: 'ケース全体',
        fluid: '流体領域',
        solid: '固体領域',
        iface: '界面',
      },
      ifaceNote:
        '界面は 2 つの領域が接することで生じるため、手動では作成できません。対流の関係式は片側が流体である必要があり、固体同士の接触では登録できません。その場合はフーリエ伝導が適用されます。',
      openAdd: '関係式を追加',
      addDialogLabel: '{{where}} で使用できる関係式',
      closeAdd: '閉じる',
      addAction: '追加',
      validOn: '{{where}}で有効',
      validNote: 'ここで有効: {{total}} 件中 {{valid}} 件',
      allFiled: 'このスコープで有効な関係式はすべて登録済みです。',
      backsolveTag: '逆算',
      // チップ上。何を求める行なのかを示し、隣の式は逆向きに読むことを述べる。
      // 通常の関係式との違いはそこだけで、空欄の意味もそれで決まる。
      backsolveTagTooltip:
        '逆向きに解きます。必要な目標値を入力すると、隣の式を反転して、その目標に到達する {{name}} を返します。結果が空なのは目標値が未入力という意味で、実行が値を出せなかったのではありません。',
      // メニュー見出しの下。一覧に逆算行が一つでもあるときに表示。チップの
      // ツールチップはキーボードでは到達できない（行のボタン内にあるため）ので、
      // その読者にはこの一行で同じ事実を伝える。
      backsolveLegend:
        '逆算行は式を逆向きに使います: 目標値を入力すると、そこに到達するために必要な入力値が返ります。',
      // チップ上。何を求める行なのかを示し、隣の式は逆向きに読むことを述べる。
      soleRegion: '{{kind}}のみ',
      unavailable: 'ここでは利用不可',
      unavailableHint: '理由を明示し、黙って省略はしません',
      emptyFiled:
        'このスコープにはまだ何も登録されていません。関係式を追加してここで計算します。',
      remove: 'このスコープから削除',
      removeNamed: '{{name}} をこのスコープから削除',
      reasons: {
        needsFluid: '流れが必要 — 流体領域に登録してください',
        needsSolid: '物体が必要 — 固体領域に登録してください',
        needsWettedWall: '壁に接する流体が必要 — この接触は固体同士です',
        needsWall: '壁が必要 — 界面に登録してください',
        needsWholeCase: '経路全体にまたがります — モデル全体に登録してください',
        ambiguous:
          '{{count}} 個の{{kind}}で一意に定まりません — いずれか 1 つに登録してください',
      },
    },
    relations: {
      resultUnitLabel: '結果の単位',
      feaInputs: {
        heading: '仮定値',
        derivedHeading: '関係式',
        resetLabel: '仮定値をリセット',
        resetTooltip:
          '実行結果と材料ライブラリから取り込んだ値をすべて元に戻します。',
        tooltips: {
          volume:
            'この実行が報告した部品体積。それが公開される前の実行では m / ρ で代用しますが、これは単一材料の部品でのみ正確です — ソルバーはボディごとの密度から質量を求めるため、アセンブリでは単一の ρ で逆算できません。体積が分かる場合は上書きしてください。',
          area: '有効断面積 — 体積を長さで割った逆算値であり、実測値ではありません。実断面が分かる場合は上書きしてください。',
          fibre:
            '中立軸から最外縁までの距離。丸断面を仮定した初期値です。実断面に合わせて上書きできます。',
          inertia:
            '断面二次モーメント。丸断面として A²/4π を初期値にしています（角断面なら A²/12）。radius_of_gyration から逆算しないでください — あれは質量ベースかつ長さ支配で、断面の曲げ剛性ではありません。',
          mass: 'この実行自体の質量（result_summary.mass_kg）。体積の種となり、以下のすべての断面量につながります。',
          length:
            '最長スパン。仕様ではメッシュのバウンディングボックスから取得しますが、このパネルでは取得しないため、入力すると以降の連鎖が計算されます。',
          load: '作用荷重の合計 — この実行の力の境界条件について大きさを合算した値。モーダル解析や熱伝導解析では宣言されないため、この欄は空のままになります。',
          density:
            '密度。この実行が宣言した材料の材料ライブラリ値です。再実行せずに別の合金を試すには上書きしてください。',
          e: 'ヤング率。同じ材料ライブラリの値です。',
          yieldStrength:
            '降伏応力。同じ材料ライブラリの値で、安全係数はこれに対して求めます。',
        },
      },
      scope: {
        fea: '構造 · FEA',
        cht: '共役熱伝達 · CHT',
        external: '外部流れ · CFD',
        internal: '内部流れ · CFD',
      },
      names: {
        fea: {
          volume: '体積',
          length: '代表長さ',
          area: '有効断面積',
          fibre: '最外縁距離',
          inertia: '断面二次モーメント',
          axialStress: '軸応力',
          bendingStress: '曲げ応力',
          deflection: 'たわみ',
          extension: '軸方向伸び',
          fos: '安全率',
          buckling: 'オイラー座屈荷重',
          frequency: '一次固有振動数',
          slenderness: '細長比',
          eulerEndFixity: 'オイラー端末拘束係数',
          cantilever: '片持ち',
          simplySupported: '単純支持',
          fixedFixed: '両端固定',
          pinnedPinned: '両端ピン',
          fixedFree: '片端固定・自由',
          beamBending: 'はり曲げ',
          axialRod: '軸方向棒',
        },
        dynamicPressure: '動圧',
        reynolds: 'レイノルズ数',
        skinFriction: '摩擦係数',
        frictionVelocity: '摩擦速度',
        firstCellHeight: '第一セル高さ',
        backSolvedCd: 'ソルバー C_D',
        handDrag: '手計算の抗力',
        backSolvedCl: 'ソルバー C_L',
        handLift: '手計算の揚力',
        refAreaFromCd: 'C_D から求めた A_ref',
        refAreaFromCl: 'C_L から求めた A_ref',
      },
      validity: {
        cantilever: '一端固定、自由端に荷重',
        simplySupported: '両端ピン支持、中央に荷重',
        fixedFixed: '両端剛結',
        pinnedPinned: '両端ピン — 基準ケース',
        fixedFree: '一端剛結、他端自由',
        beamBending: '細長く、曲げ支配',
        axialRod: '太短く、縦振動モード',
      },
      aria: {
        dynamicPressure: 'q は 2 分の 1 ロー かける U inlet の 2 乗',
        reynolds: 'レイノルズ数は U inlet かける L 割る ニュー',
      },
      notes: {
        feaBendingMoment:
          'たわみの関係式で選んだ支持条件に対する最大曲げモーメント — 片持ちばりの固定端では F·L、単純支持ばりの中央では F·L/4。',
        feaFos: '支配応力に対する値 — 曲げがあれば曲げ、なければ軸応力。',
        feaBuckling: '圧縮を受ける細長部材のみ。余裕度 P_cr / F を比較します。',
        feaFrequency:
          'はりは 3 次元部品の粗いモデルなので、一致ではなくオーダーの一致を期待してください。',
        feaSlenderness:
          'λ が大きいと曲げ・座屈が支配的、小さいとバルク／軸挙動が支配的です。',
        skinFriction:
          '平板乱流の相関式です。強い圧力勾配や剥離後流では過小評価になります。',
        backSolved:
          'この実行自体の力から逆算した値です。検証の基準ではなく、ソルバーの報告値そのものです。',
        backSolvedArea:
          'ソルバーの力と入力した係数から逆算した値。実行が宣言した基準面積の検算になります。',
      },
      indexLabel: 'この手計算の関係式',
      count_one: '{{count}} 件の関係式',
      count_other: '{{count}} 件の関係式',
      given: '既知量',
      result: '結果',
      references: '比較対象',
      referencesShort: '下に参照式あり',
      referenceOutOfRange:
        '本実行の Re・Pr では,この式の適用範囲外です。適用外であることを示すために表示しており,引用しないでください。',
      referencesHint:
        '公表されている式(読み取り専用)。該当するものを手計算で適用し,上の結果と比較してください。本パネルでは評価しません。',
      noCounterpartShort: '理想化の段階',
      resultUnavailable:
        '入力はすべて揃っていますが,この関係式の定義域を外れる値があるため算出できません。',
      runFigureMissing:
        'この実行にはこのステップが必要とする値が報告されていないため、代入できません。上の欄で補えるものではありません。',
      dimensionlessSuffix:
        '{{symbol}} — 無次元量なので、この欄には単位なしの数値を入力します。比は小数で入力し、`1%` も受け付けて 0.01 として保存します。',
      fromEarlierStep:
        'この導出の前のステップが生む値なので、ここに入力欄はありません — そのステップを埋めればこれも出ます。ダッシュはそのステップがまだ計算できないことを示します。',
      fromEarlierStepTag: '↑ 前段',
      substituteBlocked:
        '上の入力が不足しているため、この段階は計算できません。',
      pickOne: '相関式 · 1 つ選択',
      comparesTo: '{{key}} と比較',
      noCounterpart: '理想化の段階 — 比較対象なし',
      empty: 'このテンプレートの手計算関係式はまだありません。',
    },
    heading: '手計算サンドボックス',
    subhead:
      '想定していた基準値を入力してください。フィールドはソルバーの入口 BC + 流体プリセット + 基準ジオメトリからシードされます。編集すると導出値がどう変化するか確認できます。',
    dpSelectorLabel: '基準設計点',
    dpItem: 'DP #{{index}} · {{label}}',
    resetLabel: '送信値にリセット',
    resetTooltip:
      'すべてのフィールドを実行が送信された値に戻します：ソルバー入口 BC、流体プリセット、力係数基準面積/翼弦、内部流実行ではメッシュ導出入口面積。単位は SI にスナップされ、数値フィールドが実際にケースが実行された値と一致します。編集した値は設計点の切り替え時に保持されます。このボタンを押すと現在のスタディの送信値に再同期します。',
    assumptions: '前提条件',
    target: '目標',
    expected: '想定',
    firstLayer: '第1層高さ',
    derivedHeading: '導出値',
    shapePresetLabel: '典型的形状から {{coefficient}} をプリフィル',
    shapePresetTitle: {
      cd: '典型的な C_D 値',
      cl: '典型的な C_L 値',
    },
    shapePresetSubtitle: '行をクリックで入力',
    shapePreset: {
      sphereSmooth: '球（滑らか） (Sphere smooth)',
      sphereSmoothRegime: '超臨界 Re (C_D 急落後), Re > 4×10⁵',
      sphereRough: '球（粗面） (Sphere rough)',
      sphereRoughRegime: 'ゴルフボール, 境界層トリップ',
      cube: '立方体 (Cube)',
      cubeRegime: '面平行流, Re > 10⁴',
      flatPlatePerp: '平板（垂直） (Flat plate perpendicular)',
      flatPlatePerpRegime: '鈍い物体の限界',
      cylinderLong: '長円柱（横流れ） (Long cylinder)',
      cylinderLongRegime: 'アスペクト比 > 10, 亜臨界 Re',
      streamlinedHalfBody: '流線半体 (Streamlined half-body)',
      streamlinedHalfBodyRegime: '丸鼻・先細尾',
      streamlinedBody: '流線形（魚形） (Streamlined body)',
      streamlinedBodyRegime: '細身比 4:1, 付着境界層',
      teardropAxisym: '軸対称ティアドロップ (Axisymmetric teardrop)',
      teardropAxisymRegime: '理想的流線形, Re > 10⁵',
      sedanTypical: '乗用車 (Passenger sedan)',
      sedanTypicalRegime: '2010 年以降の量産車',
      sportsCar: 'スポーツカー (Sports car)',
      sportsCarRegime: '低ボンネット量産クーペ',
      suvTypical: 'SUV / クロスオーバー',
      suvTypicalRegime: '箱型の量産 SUV',
      semiTruck: 'セミトラック (Semi-truck)',
      semiTruckRegime: 'クラス 8 トラクター + トレーラー',
      naca0012_0deg: 'NACA 0012 翼型, α = 0°',
      naca0012_0degRegime: '対称, 揚力なし, Re ~5×10⁶',
      naca0012_10deg: 'NACA 0012 翼型, α = 10°',
      naca0012_10degRegime: '失速近傍, Re ~5×10⁶',
      naca2412_0deg: 'NACA 2412 翼型, α = 0°',
      naca2412_0degRegime: 'キャンバー付, 迎角ゼロで正揚力',
      naca2412_10deg: 'NACA 2412 翼型, α = 10°',
      naca2412_10degRegime: '失速前, Re ~5×10⁶',
      flatPlateThinAoA5: '薄平板, α = 5° (Thin flat plate)',
      flatPlateThinAoA5Regime: '薄翼理論: C_L ≈ 2π·α (rad)',
    },
    dynamicPressure: 'q = ½ρU²',
    backSolvedCd: 'ソルバー抗力からの C_D 逆算',
    backSolvedShort: 'ソルバー抗力から逆算',
    expectedDrag: 'C_D からの想定抗力 D',
    expectedFromCd: 'C_D からの想定',
    tooltips: {
      rho: '流体密度(kg/m³)。ソルバーの流体プリセットまたは明示的な密度オーバーライドからシード。1.204 = 20°C の空気、998 = 20°C の水。',
      nu: '動粘性 ν = μ/ρ(m²/s)。ソルバーの流体プリセットまたは明示的な粘性オーバーライドからシード。Re および y⁺ 相関に使用。',
      velocity:
        '自由流/入口速度大きさ U∞(m/s)。ソルバーの入口 BC からシード、フォールバックは報告された入口平均速度。',
      refArea:
        'C_D / C_L に用いる基準面積 A_ref(m²)。ソルバーの力係数基準面積からシード; ソルバーが実際に除算した値。変更すると、異なる A_ref 下でソルバーが報告したはずの係数を逆算します。',
      refChord:
        '基準長さ l_ref(m)。ここでは y⁺ / 境界層 Re の平板長さとしても使用。翼型では翼弦、鈍体では流れ方向の広がり。',
      yPlus:
        '第1セルの目標無次元壁距離。壁面解像 low-Re モデルでは 1、壁関数では 30–100。現在の U∞ と l_ref に対して、y⁺ をこの目標に導く第1層高さを逆算します。',
      handCd:
        '想定抗力係数; 風洞測定、Cd–Re 相関、または目標値から。入力すると下の要約テーブルの抗力比較行が有効化されます。',
      handCl:
        '想定揚力係数; C_D と同じ風洞/相関/目標ソース。入力するとソルバー Y 軸力積分に対する揚力比較行が有効化されます。',
      inletArea:
        '入口断面積 A_in（m²）。内部流ではこれがポート水力直径を通じて Re = ρU·D_h/μ を駆動します; 物体基準面積ではありません。可能な場合はメッシュ preflight から自動入力。',
      hydraulicDiameter:
        '入口ポートの水力直径 D_h = 4·V / A（m）。円管では直径そのもの、矩形ダクトでは 2·a·b / (a+b)。内部流では翼弦の代わりに Re の長さスケールとなります。',
      derivedQ:
        '動圧 q = ½ρU²（Pa）。よどみ流線でピトー管が読む全圧から静圧を引いた値。すべての力/圧力係数の正規化因子。',
      derivedRe:
        'レイノルズ数 Re = U·L/ν = ρ·U·L/μ。慣性力と粘性力の比。下の 1/7 乗則 Cf 相関は滑らかな乱流境界層に対して有効、概ね 5×10⁵ < Re < 10⁷ の範囲。範囲外では摩擦係数を過小評価します。',
      derivedCf:
        '摩擦係数 Cf = 0.026·Re^(−1/7)。平板乱流 BL の 1/7 乗則相関; Re ~ 10⁶ の外部空気力学では安価で妥当。層流（Blasius）、管内流（Moody / Colebrook 使用）、粗面支配流には不適。',
      derivedUTau:
        '摩擦速度 uτ = U·√(Cf/2) = √(τ_wall / ρ)（m/s）。壁近傍の速度スケール。ν と組み合わせて y⁺ = y·uτ/ν を決定、任意の目標 y⁺ に対する第1層高さを固定。',
      derivedY0:
        '第1セル壁法線高さ y₀ = y⁺·ν / uτ（ここでは mm に変換）。目標 y⁺ を入力すると、対数則（または壁面解像モデル）が期待通りに配置されるための第1層高さが得られます。',
      derivedBackCd:
        'C_D = D / (½ρU²·A_ref)。抗力定義の逆算：X 方向のソルバー抗力と基準面積から、実行が報告したはずの係数を計算。力係数抽出が有効化されなかった実行で有用。',
      derivedExpectedD:
        'D = C_D·½ρU²·A_ref（N）。想定 C_D からの順方向抗力。ソルバー抗力と比較することで、偏差が係数側か基準面積側かが分かります。',
      derivedBackCl:
        'C_L = L / (½ρU²·A_ref)。C_D 行と同じ逆関係、ただしソルバー Y 軸力に対して。力係数抽出が有効化されなかった実行で有用。',
      derivedExpectedL:
        'L = C_L·½ρU²·A_ref（N）。想定 C_L からの順方向揚力。ソルバー Y 力との Δ で、偏差が係数側か基準面積側かが分かります。',
      derivedBackARefFromCd:
        'A_ref = D / (½ρU²·C_D)（m²）。上の A_ref 入力の妥当性チェック：ソルバーの X 方向抗力と想定 C_D が与えられたとき、両者が一致する基準面積。入力した A_ref と比較; 典型的な設定ミスは 1 m² のフォールバック既定値がそのままソルバーに渡ること。C_D とソルバー抗力の両方が利用可能な場合のみ表示。',
      derivedBackARefFromCl:
        'A_ref = L / (½ρU²·C_L)（m²）。C_D 行と同じ妥当性チェック、ソルバー Y 力と想定 C_L に対して。C_L とソルバー揚力の両方が利用可能な場合のみ表示。',
    },
  },
  summary: {
    heading: '自己整合性チェック',
    subhead:
      '算術的恒等式と平板相関; これは一致度であり、精度ではありません。Q = U·A と q = ½ρU² は丸め誤差の範囲で一致すべき恒等式（Δ が非ゼロなら物理ではなく配管バグ）。Cf と y₀ は 1/7 乗則相関で、剥離流／非平板流では 20–50% の乖離が正当。実行の信頼度スコアとして読まないでください; 実際の信頼性シグナルはセクション 4.2 検証にあります。',
    quantity: '量',
    hand: '手計算',
    solver: 'ソルバー',
    absDelta: 'Δ',
    pctDelta: 'Δ %',
    dragX: '抗力 X(圧力+粘性、流れ方向)',
    liftY: '揚力 Y(圧力+粘性、横流れ方向)',
    dynamicPressure: 'q = ½ρU²',
    caption:
      '片側が欠けている行は「—」を表示します; サンドボックスにまだ値がないか、ソルバーがそのフィールドを出力していません。',
    tooltips: {
      cd: '抗力係数。ソルバー = 実行が報告した値。手計算 = 入力した想定 C_D。Δ % が大きい場合は真の過大/過小予測か、両者の A_ref の不一致; 上のハンドカルクパネルの基準面積行を確認してください。',
      cl: '揚力係数。ソルバー = 実行が報告した値。手計算 = 入力した想定 C_L。診断パターンは C_D と同じ; Δ が大きい場合は予測ギャップまたは A_ref 不一致。',
      liftY:
        '横流れ方向の力 = 揚力軸に沿った圧力成分 + 粘性成分。ソルバー = 実行の force_pressure_y + force_viscous_y。手計算 = C_L_想定 · ½ρU²·A_ref。',
      dragX:
        '流れ方向の力 = 流れ軸に沿った圧力成分 + 粘性成分。ソルバー = 実行の force_pressure_x + force_viscous_x。手計算 = C_D_想定 · ½ρU²·A_ref。',
      dynamicPressure:
        '動圧 q = ½ρU²。両側ともサンドボックス内の同じ ρ と U∞ から計算されるため、この行は常に 0% で一致するはず; Δ が非ゼロなら密度または速度の読み取りが異なることを意味します。',
      pressureDrop:
        'チャネル横断の物理的圧力降下 p_in − p_out。ソルバー = 実行が報告した値。v1 では手計算側は意図的に空白; 目標 Δp 入力はサンドボックスの後続作業です。',
      pressureDropKinematic:
        '運動学的圧力降下（Δp / ρ）。ソルバー内部で扱う値。上の物理 Pa 行はこれに ρ を掛けたもの。',
      inletFlow:
        '入口を通る体積流量 |Q_in| = |U_in·A_in|。手計算 = サンドボックスの U∞ · A_in。ソルバー = 実行の入口積分流量（BE は外向き面法線に対して符号付きで出力、ここでは絶対値で比較）。Δ % が 0 近くなら質量収支チェックに合格。',
      inletVelocity:
        '入口パッチの面積加重平均速度。手計算 = 入力した U∞。ソルバー = 実行の入口積分速度。両者の乖離は実際の入口面積がサンドボックスの想定と異なることを意味します; A_in を確認。',
    },
  },
  radar: {
    heading: 'L1 · 自己整合性チェック',
    subhead:
      'V&V ラダーの L1; 手計算パネルとソルバー間の算術的一致であり、検証ではありません。L2（サロゲート/DOE）、L3（検証）、L4/L5（測定; 風洞/飛行）は取り込みが実装され次第、それぞれ独自の許容帯で新しいレイヤーとして重ねられます。スコアは平均ではなく最悪軸。2 つのコードが一致し両方とも間違っている可能性があり、ここで算術的恒等式をすべて満たしても非物理的な実行はあり得ます。信頼性の判定ではなく自己テストとして読んでください。',
    pending: '未サポート',
    emptyNoCompleted: '評価対象となる完了ランがまだない.',
    emptyNoScores:
      '上の手計算パネルを埋めると自己整合を採点する — 値が入った行がそのままレーダー軸として増える.',
    worstAxisScoreTooltip:
      '0% = 最悪スコア軸が許容帯の外縁以上（恒等式は 0.1%、相関は 30%）。100% = すべての採点軸が丸め誤差の範囲で一致。表示値は採点軸の最小値であり平均ではありません; 1 つの壊滅的な軸が 5 つの良い軸で平均化されることはありません。プレースホルダー軸（隙間として描画）は除外。',
    symbol: '記号',
    identityBand: '恒等式・1% 帯',
    correlationBand: '相関・30% 帯',
    worstAxisScoreCaption: '採点軸の分布',
    worstLabel: '最悪',
    medianLabel: '中央',
    maxLabel: '最良',
    hand: '手計算',
    solver: 'ソルバー',
    score: 'スコア',
    placeholderTooltip:
      'このシグナルは未サポート。欠落軸が合格/不合格と読まれないよう、値ではなくポリゴンの隙間として描画されます。',
    series: {
      selfConsistency: '手計算 vs ソルバー',
    },
    legendCaption: '設計点',
    legendPinTooltip: 'クリックで固定; サンドボックス編集中もハイライト維持',
    legendUnpinTooltip: 'クリックで固定解除',
    symbolAnnotations: {
      pressureViscous: '圧力+粘性',
    },
    axes: {
      cd: '抗力係数',
      cl: '揚力係数',
      dragX: '流れ方向の抗力',
      liftY: '横流れ方向の揚力',
      q: '動圧',
      qIn: '入口流量',
      uIn: '入口速度',
      yPlusBands: 'y⁺ カバレッジ',
      nutRatio: '乱流粘性',
      massBalance: '質量収支',
      deadVolume: '停滞領域割合',
      blockage: 'ブロッケージ比',
    },
    tooltips: {
      cd: '抗力係数; ソルバー vs 想定値。30% 許容帯：非平板物体での大きな乖離は平板相関に対する正当な物理であり、実行の欠陥ではありません。',
      cl: '揚力係数; ソルバー vs 想定値。30% 帯、C_D と同じ理由。',
      dragX:
        '流れ方向の力の恒等式; 手計算 C_D·½ρU²·A_ref vs ソルバーの流れ軸方向の圧力+粘性力。厳しい 1% 帯；Δ は配管/基準値の不一致を示します。',
      liftY:
        '横流れ方向の力の恒等式; 手計算 C_L·½ρU²·A_ref vs ソルバーの揚力軸方向の圧力+粘性力。厳しい 1% 帯。',
      q: '動圧恒等式; 両側とも同じ ρ と U から q = ½ρU² を計算。Δ は丸め誤差の範囲でゼロであるべき；それ以外は両側が異なる入力を読んでいる可能性。',
      qIn: '入口流量恒等式; 手計算 U∞·A_in vs ソルバー入口積分流量。厳しい 1% 帯；Δ は A_in 不一致または入口 BC 反転を示します。',
      uIn: '入口速度恒等式; 手計算 U∞ vs 実行の面積加重平均入口速度。1% 帯。',
      yPlusBandsPending:
        '目標 y⁺ 帯（<5 / 5-30 / 30-100 / >100）内の濡れ壁の面積比カバレッジ; 未サポート。実装後は対数則有効範囲内に壁のどの程度が位置するかを採点。',
      nutRatioPending:
        '乱流粘性比パーセンタイル（P10 / P50 / P90）;未サポート。実装後は乱流モデルがほとんど寄与していない実行（P50 が 1 未満は乱流テンプレートでの層流的解）をフラグ。',
      massBalancePending:
        '直接的な質量収支比; このテンプレートではファーストクラスフィールドとしてまだ未サポート（現時点では |Q_in| ≈ |Q_out| から間接的に導出可能）。専用フィールド出荷までプレースホルダー。',
      deadVolumePending:
        '流れが実質的に発生しない流体領域の割合; 未サポート。ドメインの大部分が停滞していても実行が成功と報告される失敗モードを検出。',
      blockagePending:
        'ブロッケージ比（投影前面積 / エンクロージャー断面積）;未サポート。壁が自由流を絞る外部流実行での過小サイズエンクロージャーをフラグ。',
    },
  },
  surrogate: {
    loocvSummary:
      '反復 {{iteration}}、完了した {{runs}} 回の実行にわたる LOOCV：{{metrics}}',
  },
  chtViz: {
    regions: 'リージョン',
    regionLocked: '少なくとも1つのリージョンは常に表示されます。',
    uncoloured: '灰色：{{regions}}には{{field}}なし',
    uncolouredMore_one: 'ほか{{count}}件',
    uncolouredMore_other: 'ほか{{count}}件',
    noFiles: 'この実行の可視化ファイルはまだありません。',
    noSurface: 'このリージョンのサーフェスファイルはまだありません。',
  },
  viewer: {
    extremaToggle: '最大/最小',
    extremaMax: '最大:',
    extremaMin: '最小:',
    extremaMaxName: '最大値',
    extremaMinName: '最小値',
    extremaA11y: '{{quantity}}の{{name}}: {{value}}',
    extremaMoveHint: '矢印キーでこのラベルを移動できます。',
    extremaTied_one: '（同値 他{{n}}点）',
    extremaTied_other: '（同値 他{{n}}点）',
    extremaOnSlice: 'スライス上',
    extremaBehind: 'モデルの裏側',
    extremaOffView: '表示範囲外',
    lockRange: 'カラー範囲を固定',
    rangeLocked: '範囲を固定中',
    rangeClamped: '最大値が固定範囲を超えています',
    rangeMin: '範囲の最小値',
    rangeMax: '範囲の最大値',
    fitToVisible: '表示中に合わせる',
    sliceLoading: 'スライスを読み込み中…',
    sliceFieldUnavailable: 'スライスに{{field}}は含まれていません。',
    field: 'フィールド',
    visibilityShown: '{{label}}：{{total}}件中{{shown}}件を表示',
    colormap: 'カラーマップ',
    units: '単位',
    loadConditions: '荷重条件',
    boundaryConditions: '境界条件',
    volumeSurface: 'ボリューム表面',
    volumeSurfaceTooltip:
      '流体領域の簡略化表面; 選択中フィールドで色分け. 外流の場合は物体壁面も含む; エンクロージャの外形線は常時表示の独立ボックス. チェックを外すと表面に隠れずに流線 / ホットスポットを確認可能.',
    bodyOpacity: 'ボディ',
    streamlines: '流線',
    streamlineDensity: '本数',
    streamlineDensityName: '表示本数',
    streamlineDensityCount: '{{total}} 本中 {{drawn}} 本',
    streamlinesTooltip:
      '流体領域内でシードした流線; |U| で色分け, 選択中フィールドとは独立. 流れのトポロジー(付着 / 剥離 / 再循環)を表示. ソルバーが流線ファイルを出力した実行でのみ利用可能.',
    hotspots: 'ホットスポット',
    hotspotsTooltip:
      '壁面スカラー場の極値(圧力ピーク, 高温 / 低温スポット, 高 y⁺, 高 ν_t/ν). 表面上にタグ付き球として描画; 下のフィールドチップでフィルタ可能.',
    fields: 'フィールド',
    pick: {
      heading: 'ピック',
      close: 'ピック読み取りを閉じる',
      position: '位置',
      patch: 'パッチ',
      cellId: 'セル #',
    },
    customColors: {
      custom: 'カスタム',
      edit: '色を編集',
      title: 'カラーセット',
      description:
        '配色を選択するか、カスタムを選んで低値・中間値・高値の色を変更します。このウィンドウを閉じるとモデルに反映されます。',
      saveFailed: '色は保存されていません。もう一度お試しください。',
      preview: '色のプレビュー',
      low: '低',
      middle: '中',
      high: '高',
      loading: '保存した色を読み込み中…',
      loadFailed: '保存した色を読み込めませんでした。',
      saving: '色を保存中…',
      saved: '色を保存しました',
      temporary: '色はこのページにのみ適用されます。',
      idle: '',
    },
    colormapPresets: {
      'Cool to Warm': '寒色から暖色',
      'Viridis (matplotlib)': 'Viridis (matplotlib)',
      'Plasma (matplotlib)': 'Plasma (matplotlib)',
      'Inferno (matplotlib)': 'Inferno (matplotlib)',
      'Black-Body Radiation': '黒体放射',
      'X Ray': 'X 線',
    },
    aboutField: '{{field}} について',
    aboutTemperature: '温度について',
    loadingVisualization: '可視化を読み込み中…',
    loadStage: {
      listing: '結果ファイルを確認中…',
      fetching: '結果をダウンロード中…',
      parsing: '結果を読み込み中…',
      building: '3D ビューを構築中…',
    },
    loadBytes: '{{loaded}} / {{total}}',
    loadBytesSoFar: '{{loaded}} 受信済み',
    volumeUnavailable: 'ボリューム表面を利用できません：{{message}}',
    streamlinesUnavailable: '流線を利用できません：{{message}}',
    streamlinesTooShort:
      'ソルバーの流線はこの縮尺では短すぎて見えないため、描いても見えるものがありません。これはこの表示ではなく実行側の問題です。',
    streamlinesEmpty:
      'この実行では流線が生成されなかったため、ここに描くものがありません。',
    streamlinesStillborn:
      'ソルバーの流線はほぼ即座に領域外へ出るため、描いても見えるものがありません。これはこの表示ではなく実行側の問題です。',
    hotspotsUnavailable: 'ホットスポットを利用できません：{{message}}',
    slice: 'スライス',
    sliceTooltip:
      '軸に沿った平面で流体領域を切断. 表示中のスライスに合わせてカラーレンジを調整するため, 1 つのホットセルで洗い流されない.',
    sliceAxis: '軸',
    slicePosition: '位置',
    sliceUnavailable: 'スライスを利用できません：{{message}}',
    clip: '断面 (Section)',
    clipTooltip:
      '全ての境界パッチと体積表面を共通の平面で切断し, ジオメトリの内部を見る. 体積スライスの補完; こちらは表面自体を切るので, リサンプリング場のない検討でも断面表示が得られる.',
    clipAxis: '軸',
    clipPosition: '位置',
    clipFlip: '反転 (Flip)',
    clipFlipTooltip: '切断のもう一方の半分を保持.',
    probeLine: 'プローブ線',
    probeLineTooltip:
      'プローブのグラフがサンプリングしている直線を, それが横切るジオメトリ上に描画する. 直線が見たい部分と重なる場合は非表示にする.',
    boundaryPatch_one: '境界パッチ {{count}} 個',
    boundaryPatch_other: '境界パッチ {{count}} 個',
    showLess: '折りたたむ',
    showMore: '+{{count}} 件',
    hotspotsCount: 'ホットスポット（{{count}}）',
    hotspotsShowAll: 'すべて表示（{{count}}）',
    hotspotsShowLess: '折りたたむ',
    failedVisualization: '可視化の読み込みに失敗しました',
    failure: {
      notReadyTitle: '結果はまだ準備できていません',
      notReadyBody:
        'この実行はまだ結果を書き出していません。実行中であれば、完了時にここへ 3D 表示が出ます。',
      notReadyNotice: 'この実行はまだ書き出していません',
      linkExpiredTitle: 'このページを開いたままの時間が長すぎます',
      linkExpiredBody:
        '結果ファイルへのリンクは 1 時間で失効します。ページを再読み込みすると新しいリンクを取得できます。',
      linkExpiredNotice: 'リンクが失効しました。ページを再読み込みしてください',
      artifactMissingTitle: '結果ファイルが見つかりません',
      artifactMissingBody:
        'この実行が参照しているファイルは保存されていません。ページを再読み込みし、繰り返し発生する場合はお知らせください。',
      artifactMissingNotice:
        'ファイルが保存されていません。繰り返す場合はお知らせください',
      forbiddenTitle: 'これらの結果を閲覧する権限がありません',
      forbiddenBody:
        'このスタディの所有者に権限を依頼してください。他に表示されている内容は現在の権限で見られる範囲です。',
      forbiddenNotice: '現在の権限では表示できません',
      noResultsTitle: '表示できる結果がありません',
      noResultsBody:
        '3D 表示に描けるものがありません。この実行の数値とグラフには影響ありません。',
      noResultsNotice: 'この実行では生成されませんでした',
      fetchFailedTitle: '結果を読み込めませんでした',
      fetchFailedBody:
        '結果ファイルをダウンロードできませんでした。ページを再読み込みし、繰り返し発生する場合はお知らせください。',
      fetchFailedNotice:
        'ダウンロードできませんでした。ページを再読み込みしてください',
      unreadablePayloadTitle: '結果の形式が想定と異なります',
      unreadablePayloadBody:
        'この実行の可視化データはこのビューアーが読める形式ではありません。お知らせください。',
      unreadablePayloadNotice: 'このビューアーが読める形式ではありません',
      loadStalledTitle: '読み込みが止まりました',
      loadStalledBody:
        'しばらくデータが届いていません。再試行してください。再び止まる場合、この結果はブラウザで描画するには大きすぎる可能性があります。数値やグラフには影響しません。',
      loadStalledNotice: '読み込みが止まりました — 再試行してください',
    },
  },
  viewerControls: {
    showControls: 'ビューアーの操作を表示',
    mouse: 'マウス',
    dragL: '左ドラッグ',
    tumble: 'タンブル（ヨー + ピッチ）',
    dragR: '右ドラッグ',
    pan: 'パン',
    dragLR: '左 + 右ドラッグ',
    roll: 'ロール',
    wheel: 'ホイール',
    zoom: 'カーソル方向にズーム',
    rightClick: '右クリック',
    contextMenuSuppressed: 'コンテキストメニューは無効',
    ctrlL: '左クリック（静止）',
    pick: 'ピック; カーソル位置の表面を読み取り',
    keyboard: 'キーボード',
    lookAxis: 'X / Y / Z 軸方向に視点',
    pitch: '±90° ピッチ',
    yaw: '±90° ヨー',
    rollKey: '±90° ロール',
    slice: '現在のビューで断面クリップ（未接続）',
    toggleSlice: 'ボリュームスライスを切り替え',
    resetView: 'カメラを既定のビューにリセット',
  },
  guard: {
    // ガード行がバックエンドのコードで見出しを付けられた場合のラベル。
    // 件数は詳細列、理由の文章はガードパネルが持つため、短い名詞句にする。
    simErrorCode: {
      divergencePressure: '圧力が発散',
      divergenceVelocity: '速度が発散',
      divergenceTurbulence: '乱流量が発散',
      courantNumberExceeded: 'クーラン数の超過',
      nanInField: '場に NaN',
      sigfpeInField: '場に浮動小数点例外',
      massImbalanceHigh: '質量不均衡が大きい',
      continuityErrorHigh: '連続性誤差が大きい',
      wallYplusOutOfRange: '壁 y⁺ が範囲外',
      solidTRanAway: '固体温度が発散',
      interfaceUncoupled: '界面が未結合',
      heatSourceNoTarget: '発熱源に対象がない',
      inletOutletReversed: '入口と出口が逆',
      solutionHeavilyClamped: '解が強くクランプされた',
      transverseForceAsymmetry: '横方向力の非対称',
    },
    title: '結果チェック',
    subtitle: '完了したが信頼できない可能性のある計算',
    flaggedCount: '{{total}} 件中 {{flagged}} 件を検出',
    allClear: '警告シグナルなし; 完了したすべての計算は物理的に妥当です。',
    noRuns: '確認対象の完了した計算がありません。',
    unphysical: '非物理的',
    remediation: '対処方法:',
    codeLabel: 'コード:',
    reasons: {
      wallYPlusMaxAbove:
        '壁面 y+ の最大値は {{value}} で、対数則領域 ({{threshold}}) を上回っています。壁面せん断応力の値は信頼できません。',
      wallYPlusMinBelow:
        '壁面 y+ の最小値は {{value}} で、対数則領域 ({{threshold}}) を下回っています。壁関数はここでは成立しません。',
      wallYPlusBufferBand:
        '壁面面積の {{value}}% が y+ 5〜30 のバッファ層 (上限 {{limit}}%) にあり、粘性底層解像と壁関数のどちらの扱いも成立しません。壁面せん断応力の値は信頼できません。',
      wallYPlusSublayerLogLaw:
        '壁面面積の {{value}}% が y+ 5 未満 (上限 {{limit}}%) ですが、壁面処理は対数則を前提としています。壁関数はそこでは成立しません。',
      wallYPlusMeanBelowNoFractions:
        '壁面 y+ の平均値は {{value}} で、対数則領域 ({{threshold}}) を下回っていますが、壁面処理は対数則を前提としています。この計算では壁面面積の割合が得られていません。壁関数はここでは成立しません。',
      massImbalance:
        '入口と出口の質量収支が {{value}}% ずれています。計算領域で質量が保存されていません。',
      fluidLimitersClamped:
        '流体リミッタが最終反復で {{value}}% のセルをクランプしました ({{threshold}}% のしきい値を超過)。ランは収束しましたが、ソルバーが押さえ込んでいた場での収束です — クランプ領域を再メッシュまたは駆動を見直すまで、温度は参考値として扱ってください。',
    },
    remediations: {
      wallYPlusRange:
        '壁面 y+ が壁関数の有効範囲外です。初期高さを調整して y+ が 30〜100 に収まるようにしてください。',
      wallYPlusModelAware:
        '壁面 y+ がこの計算の壁面処理で扱える範囲外です。初期高さを調整してください。y+ ≈ 1 で粘性底層を解像 (k-ω SST)、30〜100 は壁関数のみ (k-ε) です。y+ 5〜30 のバッファ層は避けてください。',
      wallYPlusResolving:
        'この乱流モデルでは y+ ≈ 1 で粘性底層を解像でき、30〜100 は壁関数専用の範囲です。初期高さを y+ 5〜30 のバッファ層から外してください。y+ ≈ 1 にするなら小さく、30〜100 にするなら大きくします。',
      wallYPlusLogLaw:
        '対数則型の壁関数を使う k-ε では、第 1 セルが対数則領域にある必要があります。初期高さを上げて y+ を 30〜100 に収めるか、k-ω SST (または低レイノルズ数型の epsilon と nut の壁関数の組み合わせ) で y+ ≈ 1 として粘性底層を解像してください。',
      massImbalance:
        '入口と出口の質量フラックスの不一致が大きすぎます。BC 設定に出口漏れがないか確認するか、非直交補正回数を増やしてください。',
      solutionHeavilyClamped:
        '流体リミッタが多くのセルをクランプしたため、この解は誤りではなく信頼度が低い状態です — 収束したのはソルバーが押さえ込んでいた場です。エネルギーバランスは高めに読まれる想定です: 速度リミッタは速度場 U をセル単位で書き換えますが質量フラックスは書き換えないため、エンタルピー対流項がもはや一致しないフラックスに対して評価されます。クランプが起きている場所でメッシュを粗くするか修復するか、入口速度を下げて、温度を信頼する前に再実行してください。',
    },
    humanizedCode: {
      massImbalance: '質量不均衡 {{value}} %',
    },
  },
  cht: {
    interfaceHeatFlux: '冷媒への熱量',
    peakFlux: 'ピーク流束',
    converged: '収束',
    runtime: '実行時間',
    energyBalance: 'エネルギー保存',
    energyBalanceOk: '丸め誤差内で閉じている',
    fluxResolutionOk: '面積分値は一致',
    fluxResolutionCoarse: '面積分値が不一致 — BC面のメッシュが粗い',
    fluxResolutionCoarseFace: '面積分値が不一致 — {{face}} のメッシュが粗い',
    coarseFaceMark: '· 粗い',
    faceHeating: '加熱',
    faceCooling: '冷却',
    faceHeatRateLegendShort: '赤=加熱 · 青=冷却',
    faceHeatRateLegend:
      '正のワットは固体を加熱（赤）、負のワットは固体を冷却（青）。',
    imbalanceInflowTooltip:
      '正味流入 — 固体へ入る熱（{{in}}）が出る熱（{{out}}）より多い。不均衡は |入 − 出|。',
    imbalanceOutflowTooltip:
      '正味流出 — 固体から出る熱（{{out}}）が入る熱（{{in}}）より多い。不均衡は |入 − 出|。',
    imbalanceBalancedTooltip:
      '入熱と出熱は丸め誤差内で一致。不均衡は |入 − 出|。',
    imbalanceCoarseFace: '粗い可能性のある BC 面: {{face}}。',
    energyImbalanceTooltip:
      '閉じなかったエネルギー: |E_in − E_out − ΔU_stored|。残りが正ならその期間のエネルギー収支が保存則を満たしていない。',
    energyBalanceWarn: 'ソフトに閉じる — 説明を確認',
    energyBalanceFail: '閉じていない — ソルブがエネルギー保存を満たしていない',
    energyBalanceTooltip:
      '投入した熱が同じだけ出ていくか? 宣言熱源とソルバー界面熱流束を比較し、不均衡を % で報告する。信号 (verdict): 緑 = 一致、黄 = 説明付きで軟閉合 (未収束、速度リミッタの動作)、赤 = 閉じていない — 読者は温度を信じるべきでない。',
    iterations: '{{count}} 回の反復',
    belowLimit: '✓ {{temp}} °C の上限を下回る',
    aboveLimit: '⚠ {{temp}} °C の上限を上回る',
    regions: '領域',
    heatSource: '熱源',
    tMin: '最低温度',
    tAvg: '平均温度',
    tMax: '最高温度',
    uMax: '最高流速',
    chipTmaxTooltip:
      '熱源を持つ固体領域内の最高温度。目標温度と照合して合否バッジを決定します。',
    pressureDropTooltip: '流体領域における入口から出口への圧力損失。',
    pressureDropReversed: '圧力が上昇; 入口と出口が入れ替わっている可能性',
    interfaceHeatFluxTooltip:
      'このランで固体がすべての流体 ↔ 固体界面を通じて冷媒に渡す正味のワット数。このランの界面: {{patches}}。正の値が通常の冷却方向で, 負の値は冷媒が固体を加熱していることを意味します。界面別の内訳は領域グラフで確認できます。',
    interfaceHeatFluxIntro:
      'このランで固体がすべての流体 ↔ 固体界面を通じて冷媒に渡す正味のワット数 (負: 冷媒が固体を加熱)。',
    interfacePatchesLabel: '界面:',
    interfaceLegend:
      '矢印は熱の流れる向きを示します: 赤 = 熱を渡す領域, 青 = 熱を受け取る領域。固体 → 冷媒が通常の冷却方向で, 逆向きは通常, 入口/出口の入れ違いまたは熱源の宣言誤りを意味します。',
    interfaceHeatFluxTooltipTrans:
      'このランで固体がすべての流体 ↔ 固体界面を通じて冷媒に渡す正味のワット数。界面: {{patches}}。<heat>赤</heat> = 熱を渡す領域, <cool>青</cool> = 熱を受け取る領域。固体 → 冷媒が通常の冷却方向です。',
    peakFluxTooltip:
      '流体 ↔ 固体界面上の任意の場所での最大局所熱流束。このランのピーク位置: {{patch}}。値が高いほどメッシュ細分化が必要なホットスポットを示します。',
    peakFluxIntro: '流体 ↔ 固体界面上の最大局所熱流束。',
    peakPatchLabel: 'ピーク位置:',
    peakFluxOutro: '値が高いほどメッシュ細分化が必要なホットスポットを示す。',
    peakFluxTooltipTrans:
      '流体 ↔ 固体界面上の最大局所熱流束。ピーク位置: <heat>{{patch}}</heat>。値が高いほどメッシュ細分化が必要なホットスポットを示す。',
    patchListUnavailable: 'このランでは報告されていません',
    convergedTooltip:
      'ソルバーの残差が反復回数を使い切る前に設定された許容値を下回ったかどうか。✓ は解が定常であることを、;は反復予算をすべて使っても収束しなかったことを示します。',
    runtimeTooltip:
      'ソルバーがこの設計点に費やした実時間の秒数（メッシュ生成時間は含まない）。',
  },
  chtAnchors: {
    subtitle:
      '実行が想定する参照値を入力してください。実行結果と材料ライブラリから初期化できる欄は自動入力されます; D_h と L も実行に宣言値があれば自動入力されます。空欄のままの項目は手入力してください。Reset で全欄を初期値に戻します。',
    assumptionsHeading: '仮定',
    derivedHeading: '導出',
    resetLabel: '仮定を初期値に戻す',
    resetTooltip: 'リセット',
    refPickerLabel: '{{row}} の参照値',
    missingInputHint: '{{variable}} 待機中',
    refPickerTitle: '参照値',
    refPickerHint:
      '参照式 — 読み取り専用。ヒートシンクに合う形状を選び、手計算で式を適用してから、上の行に結果を入力してください。',
    refs: {
      genericCoolant: 'この冷却液',
      Nu: {
        laminarWallT: '層流管路・壁温一定',
        laminarWallQ: '層流管路・壁熱流束一定',
        gnielinski: '乱流 (Gnielinski)',
        dittusBoelter: '乱流 (Dittus-Boelter)',
        description: {
          laminarWallT:
            '十分に発達した層流・壁温一定の円管に対する定数です。相関式ではなく速度・温度分布の解から直接得られるため、フィッティングもばらつき帯もありません。下限値として使ってください — 層流チャネルがこれを下回ることはありません。',
          laminarWallQ:
            '同じ解析で壁面境界条件を一定熱流束にした場合です。一定熱流束の分布は (T_wall − T_bulk) に対して壁面勾配が急なまま保たれるため値が大きくなります。壁温一定では、流体が壁温に近づくにつれてその勾配が緩みます。どちらを使うかは流れではなく境界条件の問題です。',
          gnielinski:
            '汎用の乱流相関式であり、適用範囲内ではこちらを優先してください。遷移域を含み、Prandtl 数の範囲も広く、平滑管を仮定せず摩擦係数を明示的に含みます。分子に (Re − 1000) を含むため Re ≈ 1000 未満では負値を返しますが、これは適用範囲外を示すサインであって計算結果ではありません。',
          dittusBoelter:
            '古い簡易な乱流相関式です。手計算しやすく今も広く引用されますが、実測に対しておよそ ±25 % の精度にとどまります。壁面とバルクの物性変化を無視するため、温度差が大きいほどずれが大きくなります。{{fluid}} では粘度が温度で変化するため、この影響は無視できません — それこそが Sieder-Tate の (μ/μ_s) 項が補正する対象であり、本相関式が省いている点です。適用範囲内なら Gnielinski を優先し、Gnielinski と Dittus-Boelter の一致は「安心材料」として扱ってください — どちらも真値ではありません。',
        },
        validity: {
          laminar: '十分に発達した層流 — Re < 2300',
          gnielinski: '3 × 10³ < Re < 5 × 10⁶,0.5 < Pr < 2000',
          dittusBoelter:
            'Re > 10⁴,0.7 < Pr < 160,かつ助走区間が管径の 10 倍以上',
        },
      },
      eps: {
        rectStraight: '矩形フィン',
        triangularStraight: '三角形フィン',
        annular: '環状フィン',
        pinFin: 'ピンフィン (円柱)',
        arrayOverall: 'フィン配列全体効率 η_o',
        ntuPredicted: '流路の流れから予測',
        validity: {
          ntuPredicted:
            '単一流体・壁温一定,かつ Gnielinski の適用範囲 (3 × 10³ < Re < 5 × 10⁶,0.5 < Pr < 2000). 実行の発熱量・温度を一切使わないため,上の行との差は計算の焼き直しではなく判断材料になる.',
        },
      },
    },
    units: {
      massFlow: 'kg/s',
      specificHeat: 'J/(kg·K)',
      dimensionless: '無次元',
    },
    backsolve: {
      heading: '逆算',
      subtitle:
        '想定される参照値を入力すると、パネルが定義式を逆解きし、事前登録用の予測結果、またはサイジング用の形状/設定入力を返します。主入力の下に副入力がある行は、実行が報告しない追加の数値 (D_h, A_in, A_wet) を必要とするため、その行内でインラインで入力してください。',
      headers: {
        row: '行',
        typeIn: '入力',
        typeInHint:
          '主入力はその行の想定参照値です。隣の小さな入力欄は実行が持たない形状値 — D_h (水力直径)、A_in (入口断面積)、A_wet (界面湿潤面積)。逆算する行に必要な値を入力してください。',
        backsolve: '逆算結果',
      },
      rows: {
        R: {
          label: 'R 想定 → 予測 T_source',
          hint: '想定する熱抵抗を入力すると、実行が到達する温度を返します。T_source = T_in + Q̇·R_exp を事前登録し、実行のホットスポット温度と比較。',
          output: 'T_source',
        },
        rthQMax: {
          label: '目標 T + R_th → パッケージ熱流量バジェット Q̇_max',
          hint: 'R 想定行の相補的な反解。部品が超えてはならない温度と（右横の R_exp 補助入力に）想定する熱抵抗を入力すると、Q̇_max = (T_target − T_in) / R_exp — 接合部が制限を超える前に配管系が運べる最大熱負荷 — が得られます。パッケージ選定の熱流量バジェット、あるいは熱源が電子部品でない場合（ヒーター素子、モーターコイル、LED）のディレーティング確認に使用。T_target と R_exp の双方を入力し、かつ T_target > T_in である間だけ有効。',
          qMax: 'Q̇_max',
        },
        dtBudget: {
          label: 'ΔT 予算 → 必要 ṁ + U_inlet',
          hint: '許容される冷媒エンタルピー上昇 ΔT と宣言された Q̇ から、必要な冷媒質量流量は ṁ = Q̇/(c_p·ΔT)。ρ·A_inlet で割ると設定に入力する入口速度が得られます。',
          mDot: 'ṁ',
          uInlet: 'U_inlet',
        },
        epsExpected: {
          ntuTip:
            'NTU (Number of Transfer Units, 伝熱単位数) = U·A / C_min — 熱交換器の無次元伝熱サイズ。冷媒を平均 ΔT で何回加熱できるかの概念。単一流 / 壁温一定で NTU 1 / 2 / 3 → ε 0.63 / 0.86 / 0.95。',
          label: 'ε 想定 → 必要 NTU + U·A_wet',
          hint: '熱交換器 ε (Kays & London) であり、フィン効率ではありません。ε は入力値: 目標有効率 (理想 ΔT のうち回収する割合) をここで指定します。右側の NTU と U·A_wet はこの行が計算する値です。1.0 に近づくほど面積コストが急増します。NTU (Number of Transfer Units) = U·A / C_min は熱交換器の無次元伝熱サイズを表します。単一流 / 壁温一定: NTU = −ln(1−ε)、U·A_wet = NTU · ṁ · c_p。NTU 1 / 2 / 3 → ε 0.63 / 0.86 / 0.95。対向流・並流・直交流・混合配置は各々固有の ε-NTU 曲線を持つため Kays & London を参照。フィン面には Incropera 第 3 章のフィン効率 η_fin を使用してください。',
          // A symbol, so the same in every locale — but a key rather than a
          // literal, because every other output label on these rows is one and
          // the renderer translates them all the same way.
          ntu: 'NTU',
          uaWet: 'U·A_wet',
          arrangement: '配置',
          arrangementValue: '単一流 / 壁温一定',
        },
        piBudget: {
          label: 'Π 予算 → 最大 Δp',
          hint: 'Π = Δp / (ρ · c_p · ΔT)。ポンピングコスト予算を「比」で入力します (通常 < 1 %) — 0.01 でも 1% でも同じ値が保存されます。これを選ぶと、この冷却仕事にループが費やせる最大圧力損失を返します — ポンプ側の上限。',
          dP: '最大 Δp',
        },
        reTarget: {
          label: 'Re 目標 → 必要 U_inlet',
          hint: '相関式行が有効となるレイノルズ数と流路の水力直径から、必要な入口速度は U = Re · ν / D_h。',
          uInlet: 'U_inlet',
        },
        nuExpected: {
          label: 'Nu 想定 → 予測壁 ΔT',
          hint: 'この流路の公表 Nu を入力すると、壁が冷媒より何度高いかを返します。ΔT_wall = T_wall − T_coolant — 単なる ΔT (一部の教科書では壁面過熱とも呼ばれます)。式: h = Nu · k_fluid / D_h、ΔT_wall = q″ / h (q″ ≈ Q̇_in / A_wet)。実行のピーク熱流束に対して壁 ΔT を事前登録できます。',
          h: 'h',
          dtWall: 'ΔT_wall',
        },
        targetT: {
          label: '目標 T_max + Q̇ → 必要 Nu (実現可能性)',
          hint: '目標ホットスポット温度と宣言熱流量から、必要な h は Q̇ / (A_wet · (T_target − T_bulk))、必要な Nu は h · D_h / k_fluid。到達可能な Re で相関式が与える Nu を Nu_req が超えると、その設計は達成できず、どんなメッシュも修正できません。',
          hReq: 'h_req',
          nuReq: 'Nu_req',
        },
        biLimit: {
          label: 'Bi 最大値 → 最大集中容量固体 L_max',
          hint: '固体をどこまで厚くしたら「均一な一温度」として扱えなくなるか? 集中容量近似で許容する Biot 数の最大値を入力 — 教科書標準は 0.1 (Incropera 第 5 章)。Bi_max は「集中容量として扱える最大 Bi 」を意味する上限値です (小さい Bi = 内部均一)。集中容量近似が成立する最大厚さ L_max を返します。これより厚いと内部に無視できない ΔT が生じ、表面温度は内部最高点を代表しなくなります。式: L_max = Bi_max·k_solid / h。厚さ固定で高伝導率材料を探すなら k_req = h·L / Bi_max に逆算。h は上の Nu 想定行、または目標-T 実現可能性行から取得 — 出力行がどちらを使ったかを表示します。h が「利用不可」なら、まずどちらかを埋めてください。',
          lMax: 'L_max',
          h: 'h',
          hSource: 'h の出所',
          hSourceNu: 'Nu 想定行',
          hSourceTargetT: '目標-T 実現可能性行',
          hSourceNone: '利用不可 — Nu 想定または目標-T を先に埋めてください',
          hSourceNuShort: 'Nu 由来',
          hSourceTargetTShort: '目標-T 由来',
        },
        rePlusPr: {
          label: 'Re + Pr → 最小発達長さ',
          hint: '層流 (Re < 2300): L_t ≈ 0.05·Re·Pr·D_h、L_h ≈ 0.05·Re·D_h。乱流: L_t ≈ L_h ≈ 10·D_h。これより短い流路は発達流ではなく発達過程流の相関式行に該当します。',
          lT: 'L_t (熱)',
          lH: 'L_h (流体力学)',
        },
        interfaceScale: {
          label: '界面フラックス対 → A_wet スケールチェック',
          hint: 'A_wet ≥ Q̇_iface / q″_peak。自動 — 入力不要。この下限が CAD と ~100 倍以上ずれる場合、単位 / スケール誤りが疑われます (CFD の長さスケールチェックの CHT 版)。',
          aWetMin: '最小ぬれ面積',
        },
      },
    },
    radar: {
      heading: '自己整合性レーダー',
      subtitle:
        'スコアは最悪軸のみ。実行が全ての算術的恒等式をここで通過してもなお非物理的である可能性があるため、自己テストとして読んでください。',
      empty: 'スコア対象の完了 CHT 設計点がまだありません。',
      noScoreable:
        'この実行には宣言された熱源も冷媒側データもありません — すべての軸がブロックされているため、レーダーは何も描画できません。総発熱量を宣言するか、冷媒フィールドを出力する実行をお待ちください。',
      identityBand: '恒等式 · 1% 帯',
      correlationBand: '相関 · 30% 帯',
      pending: '実行の界面データ待ち',
      distributionHeading: 'スコア軸分布',
      worst: '最悪',
      median: '中央値',
      best: '最良',
      symbol: '記号',
      hand: '手算',
      solver: 'ソルバー',
      deltaPct: 'Δ %',
      score: 'スコア',
      placeholderTooltip:
        'この軸はプレースホルダー — ソルバーがまだ両側を出力しません。',
      kinds: {
        identity: '恒等式',
        correlation: '相関',
        placeholder: 'プレースホルダー',
      },
      axes: {
        // 電力 = electric power specifically; the axes carry a heat
        // POWER (energy/time) so 熱流量 (heat-flow rate) reads
        // correctly in the thermal-engineering register.
        qInterface: '界面熱流量',
        qCoolant: '冷媒熱流量',
        qCoolantInterface: '冷媒↔界面',
        qV: '体積発熱密度',
        epsilon: '有効度',
        R: '熱抵抗',
        Bi: '固体均温性',
        Nu: 'ヌセルト数',
        j: 'コルバーン j 因子',
      },
      tooltips: {
        qInterface:
          '宣言された投入熱量とソルバーが報告する流体–固体界面熱流束の比較。恒等式 — 収束実行では丸め誤差内で閉じるべき。',
        qCoolant:
          '宣言された投入熱量と冷媒エンタルピー上昇 (ṁ · c_p · ΔT) の比較。恒等式 — 新しいソルバー実行の冷媒側集計が必要。',
        qCoolantInterface:
          'ソルバー側の 2 つの熱量を相互チェック: 流体–固体界面の熱流束 vs 冷媒が持ち出すエンタルピー (ṁ · c_p · ΔT)。宣言値と独立 — 不一致はソルブがエネルギー保存を満たしていない (集計漏れの壁面、部分バランス) 兆候。恒等式 — 丸め誤差内で閉じるべき。',
        qV: '体積発熱密度 q̇_v = Q̇/V_source、宣言側 vs 測定側 (Q̇_interface/V_source)。恒等式 — 熱源固体に投入したすべての W が流体界面から出ていくことを表す。差異は界面集計に含まれない熱経路 (固体側の環境 BC、別の固体–固体界面) を示す。熱源固体の網格化体積が報告されない旧い実行ではブロックされる。',
        epsilon:
          'ε = Q̇ / (ṁ · c_p · ΔT_max)。典型的 ε-NTU 至適 ~0.7 に対する相関帯スコア。',
        R: 'R = (T_source − T_in) / Q̇。典型的液冷コールドプレート目標 ~1 K/W に対する相関帯スコア。',
        Bi: 'Bi = h · L / k_solid。スコア判定には実行がまだ出力しない h 推定 (濡れ界面積 + 壁–バルク ΔT) が必要。',
        Nu: 'Nu = h · D_h / k_fluid。スコア判定には実行がまだ出力しない h 推定 (濡れ界面積 + 壁–バルク ΔT) が必要。',
        j: 'j = St · Pr^(2/3)。スコア判定は Nu / Bi と同じ h 推定を待機中。',
      },
    },
    chtChecks: {
      heading: '一致性チェック',
      subtitle:
        '正常な実行では丸め誤差の範囲で必ず一致すべき恒等式。Δ はプラミングバグ (ラベル入れ替え、null をゼロと誤読、部分的エネルギーバランス) であって検証信号ではありません。',
      headers: {
        identity: '恒等式',
        hand: '手算',
        solver: 'ソルバー',
        absDelta: '|Δ|',
        pctDelta: 'Δ %',
      },
      rows: {
        qInterface: {
          label: '投入熱量 ↔ 流体–固体界面通過熱量',
          hint: 'この実行の固体領域に宣言された熱源 (モーターコイル、ヒーター素子、LED、チップダイなど) の合計と、ソルバーが報告する界面熱流束を比較します。収束した実行では丸め誤差以内で閉じるはず。大きな Δ はソルバーが宣言熱量を流体–固体界面まで届けきれていないことを意味します。',
        },
        qCoolant: {
          label: 'エンタルピー保存 · 投入熱量 ↔ ṁ·c_p·ΔT',
          hint: 'エンタルピー保存チェック: 冷媒のエンタルピー上昇 (ṁ · c_p · ΔT) は固体領域に宣言された熱源合計と一致するはず。大きな Δ は冷媒が持ち出す熱量が熱源の投入量より多い/少ないことを示す — 環境 BC 経由の漏れ、符号違い、入口/出口の入れ違いなどが原因。新しいソルバー実行の冷媒側集計フィールドが必要。',
        },
        qBothSides: {
          label: '|Q̇_fluid| ↔ |Q̇_solid| (界面閉合)',
          hint: 'ソルバー側のみのチェック — 流体側界面が受け取る熱量は、固体側が放出する熱量と符号反転で一致するはず。符号規約に依存せず読めるよう絶対値で比較。宣言値とは独立 — 差異は界面カップリング自体が閉じていない (ソルバーが集計しなかったパッチ対、メッシュ非直交性による熱流束不均衡) ことを示す。',
        },
        qCoolantInterface: {
          label: 'エネルギー保存 · Q̇_interface ↔ ṁ·c_p·ΔT',
          hint: 'ソルバー側の 2 つの熱量を相互チェック: 流体–固体界面熱流束 vs 冷媒が持ち出すエンタルピー。宣言値と独立 — 不一致はソルブがエネルギー保存を満たしていない (集計漏れの壁面、部分バランス) ことを示す。qInterface と qCoolant が個別に閉じていてもこの 2 つが不一致となる場合をこの行が捕捉する。',
        },
        qV: {
          label: '体積発熱密度 · Q̇/V_source ↔ Q̇_iface/V_source',
          hint: '宣言側の体積発熱密度 (Q̇/V_source) と測定側 (Q̇_interface/V_source) の比較。閉合すれば熱源固体に投入したすべての W が流体界面から出ていくことを意味。差異は界面総和に含まれない熱経路 (固体側の環境 BC、別の固体–固体界面) を示す。熱源固体の網目化体積が必要。',
        },
        massImbalance: {
          label: 'ṁ 入口 ↔ ṁ 出口 (質量バランス)',
          hint: 'ソルバーの冷媒質量不均衡は ~0 であるべき。非ゼロはソルバーが質量バランスを丸め誤差内で閉じられていないことを意味します。',
        },
      },
      pending: {
        qDeclared:
          '比較する投入熱源がありません — 宣言するか熱流量を手動入力してください。',
        interface: '開発中。',
        coolant: '開発中。',
      },
    },
    tooltips: {
      dh: '流路の水力直径。実行に宣言値があればそれで初期化; なければ形状値または妥当な推定値 (4·A/P) を入力。いずれの場合も宣言値であり計算結果ではありません。',
      L: '固体の熱伝導経路特性長 (通常は熱が通過する固体厚み)。実行に宣言値があればそれで初期化; なければ手入力。計算結果ではありません。',
      qDot: 'この実行の固体領域に宣言された総発熱量の合計。W/m³ 密度で宣言された実行は、実行が報告しない領域体積が必要なので手動入力。',
      tSource:
        '最高固体温度 — 実行が名指しした場合は熱源固体の最高温度、なければ全固体領域の最高温度。',
      tIn: '流体入口温度 — 実行に投入された境界条件より。',
      dP: '流体領域の圧力損失。',
      mDot: '冷媒質量流量 — 新しい実行では自動、古い実行では空。空欄なら手動入力。',
      dT: '冷媒エンタルピー上昇 — 質量流量と同じ配線状況。',
      kSolid:
        '材料ライブラリから取得した固体熱伝導率 (最初の固体領域の材質による)。多固体構成でも1値のみ表示; Bi の領域別 k_solid は今後の課題。',
      kFluid: 'FLUID_MATERIAL ライブラリ項の値をそのまま使用。',
      rho: '実行に投入された冷媒のライブラリエントリから取得した流体密度。',
      cp: '実行に投入された冷媒のライブラリエントリから取得した流体比熱。',
      prandtl:
        '流体プラントル数。ライブラリ項から Pr = ρ·ν·c_p/k として算出され、ソルバーに渡される値。',
      vSolid:
        '熱源固体の網目化体積 — 発熱源が宣言されている領域の体積。q̇_v = Q̇ / V_solid に用いる；パッケージ定格に対する接合部密度確認に使用。',
      aWet: '流体 ↔ 固体すべてのパッチ対の濡れ界面積の合計。h_eff = Q̇ / (A_wet · ΔT) に用いる。古い実行では空欄 — その場合 h_eff は L² 近似にフォールバックする。再実行なしで設計変更をテストするため上書き可能。',
    },
    state: {
      needsCoolant: 'ソルバーの冷媒集約値 (ṁ + ΔT) を待機中。',
      needsDh: '水力直径 D_h の入力が必要です。',
      needsBoth: 'ソルバーの冷媒集約値と水力直径 D_h の両方を待機中。',
      missingInputs: '入力不足: {{missing}}',
    },
    rows: {
      R: {
        label: '熱抵抗 R',
        reference:
          '部品が逃がさなければならない 1 W あたり何度上がるか。低いほど良い。液冷コールドプレートは通常 0.1〜10 K/W——ずれは伝導／壁〜冷媒／冷媒昇温に分解してどこで外れたかを見る。',
        source: '熱オームの法則・単相液冷コールドプレート設計指針',
      },
      Bi: {
        label: '固体の均温性 (Bi)',
        observed: 'Δ{{region}} = {{dt}} K',
        reference:
          '固体部品がほぼ一温度とみなせるかを確認する。金属は通常可；内部の大きな温度差は部品接触や設定の材料値を指す。Bi < 0.1 = 集中容量；方向のみの検査なので、実測温差が Bi 予測を上回るときは界面結合や伝導率入力を疑う。',
        source: '集中容量法・Incropera 5章',
      },
      Nu: {
        label: 'ヌセルト数 Nu',
        reference:
          '流動冷媒が静止流体よりどれだけ熱を運ぶかを採点する。流路種別に対する公表値と比較：Shah & London 層流の厳密値 3.66 / 4.36（壁条件で 19 % 動く）、Gnielinski ±10 %（3 × 10³ < Re < 5 × 10⁶）、Dittus-Boelter ±25 % フォールバック。',
        source: 'Gnielinski；Dittus-Boelter；Shah & London・Incropera 8章',
      },
      Pi: {
        label: 'ポンピングコスト Π',
        reference:
          '除去した熱 1 W あたりに使うポンプ動力ワット数。健全な液冷ループは 1 % を大きく下回る。Π の上昇は温度が動く前に流路水力の問題を示す。',
        source: 'Π = V̇·Δp / (ṁ·c_p·ΔT) = Δp / (ρ·c_p·ΔT)・液冷ループ設計指針',
      },
      j: {
        label: 'コルバーン係数 j',
        reference:
          '実行自身の交差確認：熱の答えと圧力損失の答えは同じ壁物理から来て一致すべき。壁せん断が Δp を支配する範囲では j ≈ f / 8、±20 %；ピンフィンは f の近道を破り、測定した j(Re) は有効のまま。',
        source: 'Chilton-Colburn 相似則・Incropera §6.8',
      },
      eps: {
        label: '有効度 ε_HX',
        reference:
          '熱交換器有効度 — この冷却器がその配置で実現可能な最大熱交換にどれだけ近づいているか。1.0 が物理限界。ε = Q̇_in / (C_min · ΔT_max)、C_min = ṁ·c_p。配置別の ε-NTU 曲線 (Kays & London, ±10 %) と比較。単一流 / 壁温一定: ε = 1 − e^(−NTU)。フィン有効度 ε_fin = q_fin / (h·A_b·(T_b − T_∞)) やフィン効率 η_fin とは別物 — フィン面には Incropera 第 3 章の表 (矩形 / 三角形 / 環状 / ピンフィン) を参照。',
        source: 'Kays & London・Compact Heat Exchangers',
      },
      qV: {
        label: '体積発熱密度 q̇_v',
        reference:
          '熱源固体が単位体積あたり放出するワット数 — パッケージデータシートの接合部密度指標 (ヒーター素子、コイル、LED でも同様)。Q̇ / V_solid、V_solid は熱源を持つ領域の網目化体積。典型的な CPU ダイは 10⁸ W/m³ (100 MW/m³) 付近。それを大きく超えると熱源固体の面積が放熱能力を上回っている合図で、冷媒側の状況によらず高温を示す。',
        source: '接合部密度指標・パッケージ定格との比較',
      },
      Rcond: {
        label: '熱伝導抵抗 R_cond',
        reference:
          '固体経路のフーリエ抵抗 L / (k_solid · A)。流体が接していない面に適用できる関係式で、固体同士の接触には熱伝達率が存在しないため Nu・Colburn j・第一セル高さはいずれも定義されません。同じスコープで実行値 R = ΔT / Q̇ と同じ K/W 単位で比較します。一致すれば想定した厚みのバルク伝導として振る舞っていることを意味し、手計算値がソルバー値より小さい場合は理想経路にはない接触抵抗（隙間、熱伝導グリース、不完全な接合）があることを示します。',
        source: 'フーリエ伝導 · 一次元平板',
      },
      hEff: {
        label: '有効界面熱伝達係数 h_eff',
        reference:
          '壁の対流熱伝達係数のオーダー推定。Q̇ / (L²·ΔT_wall→bulk) — Bi / Nu / j で内部的に用いる h を明示行として出したもの。対流 BC の宣言 h と比較できる。網目側の A_wet が出るまでは L² を代用。水流路 10³〜10⁴ W/(m²·K)、強制空冷 50〜500、沸騰 10⁴〜10⁵。',
        source: 'ニュートン冷却則・h = q″ / ΔT・Incropera 第 6 章',
      },
    },
  },
  fea: {
    fixtureLoadFaces: '拘束面と荷重面',
    hideFace: '{{face}} を非表示',
    showFace: '{{face}} を表示',
    field: 'フィールド',
    aboutField: 'この場について',
    slice: '断面',
    slicePosition: '断面位置',
    sliceInBody: '{{position}} mm · {{label}}（{{volume}}）内',
    sliceInBodyUnlabeled: '{{position}} mm · {{volume}}内',
    viewAlongSlice: '{{axis}}方向に見る',
    bodies: 'ボディ',
    coloredFaces: '色付き面',
    otherFaces: '面',
    fixturesAndLoads: '拘束と荷重',
    thermalBoundaryConditions: '熱境界条件',
    contactsAndPreloads: '接触と予荷重',
    contactsBondsAndPreloads: '接触・結合と予荷重',
    interfacesAndTies: '界面と結合',
    highlightTarget: '{{detail}} をハイライト: {{label}}',
    detailsAndHighlightTarget: '{{detail}} の詳細とハイライト: {{label}}',
    notReported: '未報告',
    sharedMeshInterfaces: '共有メッシュ接合',
    sharedMeshInterfaceHint:
      '共通のメッシュ面または辺で結合したボディの組。辺のみの接合には熱伝導面積がありません。古いメッシュは再メッシュすると形状とハイライトを表示できます。',
    edgeOnlyJoin: '辺のみ',
    pointOnlyJoin: '点のみ',
    areaUnavailable: '再メッシュで面積を表示',
    bodyUnassigned: '未割り当て',
    deformedShape: '変形形状',
    scale: '変形スケール',
    scaleAuto: '自動 ({{factor}}倍)',
    scaleFactor: '実寸の {{factor}} 倍',
    reactionsTitle: '拘束部の反力',
    reactionsHint: '各支持部が受ける力 — 入力ではなく解析結果',
    reactionFixture: '拘束部',
    reactionTotal: '合計 (N)',
    reactionAxial: '軸力 (N)',
    reactionShear: 'せん断力 (N)',
    reactionTension: '引張',
    reactionBearing: '圧縮',
    reactionNodes: '{{count}} 節点',
    reactionNoNormal: '面法線が一意でないため合計のみ',
    peak: '最大 {{value}} {{unit}}',
    mode: 'モード',
    modeOption: 'モード {{mode}} · {{frequency}}',
    modeNa: 'N/A',
    frequencyHz: '{{frequency}} Hz',
    failedVisualization: '可視化の読み込みに失敗しました',
    legacyArtifact:
      'ラインプローブとボディ別表示には再実行が必要です。この結果には体積接続情報がありません。',
    lineProbeUnavailable:
      'この FEA 結果には表面 VTU があるためモデル上でプローブ線を配置・確認できますが、場の補間に必要なボリュームツリーがありません。体積結果アーティファクトを有効にして再実行するとサンプルを描画できます。',
    scrubber: {
      label: 'フレーム',
      play: '再生',
      pause: '一時停止',
      slider: '結果フレーム',
      value: '{{value}} {{unit}}',
      frames: 'フレーム ({{count}})',
      framesHelp:
        'この軸に沿って公開された結果フレームは {{count}} 個です。再生は 0.25 秒ごとに 1 フレーム進め、端で折り返します。スクラブはメッシュを載せ直さず対応する場のシャードを読み込みます。',
      unit: {
        time_s: 's',
        frequency_Hz: 'Hz',
        load_factor: '×',
      },
    },
  },
  // ENG-1545 Block G; 付録 — 引用文献とデータのトレーサビリティ。
  figures: {
    addChartToWriteup: '「{{alt}}」をレポート本文に追加',
    axis: {
      distance: '線に沿った距離 (mm)',
      term: '項',
      flowRate: '流量',
      check: '検査項目',
      input: '入力変数',
      iteration: '反復回数',
      residual: '残差',
      score: 'スコア',
      value: '値',
      varianceShare: '分散寄与率',
    },
    boundsFitted: '軸範囲は表示データに合わせています。',
    unmeasured_one:
      '{{count}} 点は未計測であり、ゼロではなく空白として描画されています。',
    unmeasured_other:
      '{{count}} 点は未計測であり、ゼロではなく空白として描画されています。',
  },
  appendix: {
    references: {
      heading: '引用文献',
      empty:
        'この研究テンプレートに該当する事前登録の参照はありません。結果セクションの参照比較ピッカーから追加できます。',
    },
    traceability: {
      heading: 'データのトレーサビリティ',
      studyId: '研究 ID',
      generatedAt: 'レポート生成時刻',
      designPoints: '設計点',
      dpCount: '{{total}} 件中 {{completed}} 件が完了',
      geometryIds_zero: 'ジオメトリ ID',
      geometryIds_one: 'ジオメトリ ID',
      geometryIds_other: 'ジオメトリ ID ({{count}} 件)',
      meshIds_zero: 'メッシュ ID',
      meshIds_one: 'メッシュ ID',
      meshIds_other: 'メッシュ ID ({{count}} 件)',
      simulationIds_zero: 'シミュレーション ID',
      simulationIds_one: 'シミュレーション ID',
      simulationIds_other: 'シミュレーション ID ({{count}} 件)',
      attemptTag: '(試行 {{attempt}})',
    },
  },

  overview: {
    help: {
      completion:
        '要求された全荷重ステップの完了を確認します。完了だけでは強度、安定性、力の釣り合いを検証できません。',
      contact:
        '定義された接触対の記録済み開離を確認します。記録がない場合、閉じた状態とは判断できません。',
      forceBalance:
        '最終状態の外力と支持反力を全体座標 X、Y、Z で比較し、共有拘束節点・自由度を一度だけ数えます。完全な荷重データと記録許容値内の不釣合い力が必要です。旧結果は新版バックエンドで再実行または出力の再処理が必要です。',
      moment:
        '質量加重されたアセンブリ重心まわりの作用モーメントと支持反力モーメントを比較します。これは全体釣り合いの合モーメントであり、断面の最大内部曲げモーメントではありません。',
      mesh: '同じ物理量を少なくとも三つの比較可能なメッシュ解像度で比較します。一つのメッシュだけでは独立性を検証できません。',
      anchor:
        '同じ設計点・現在の実行に対応する独立計算と比較します。計算を生成し、不足する仮定を入力してください。欠測は合格ではありません。',
      residuals:
        '記録された残差を適用される収束条件と比較します。処理の完了や一つの方程式の小さな残差だけでは収束の証明になりません。',
      guard:
        'このソルバーと設定の物理検査記録を使用します。対象設計点で警告の原因を確認してください。',
      mass: '入口と出口の積分質量流量を比較します。百分率は記録された相対不釣合い量です。流量が欠測の場合は未評価です。',
      bounding:
        '計算値を数値的な許容範囲に補正した記録です。収束や材料強度とは別です。記録がなくても補正なしとは判断できません。',
      yPlus:
        '現在の壁面処理に対する近壁メッシュ解像度を確認します。流体モデル用で、構造 FEA には適用しません。',
      modes:
        '記録された固有振動数と要求モードの抽出数を示します。各モードに固有の周波数があり、最低値は全スペクトルを表しません。',
      nonPositive:
        '非正の固有値または周波数の数です。モード番号ゼロではなく、ゼロ近傍の正値モードすべてを検出するものでもありません。',
      heat: '最終ステップの境界面積分で入熱と出熱を比較します。帯は max(入／出の大きい方の 1%, 0.000001 W) です。これらの積分は要素温度勾配の復元値に基づくため、差が大きい場合は境界勾配のメッシュ解像不足を示します。助言的な検査であり、エネルギー保存の失敗でもソルバー収束失敗でもありません。節点反力から読んだ面ごとの熱流量はこれらの積分と異なる場合があります。',
      energyConserved:
        '期間の固体への入出エネルギー（∫Q·dt）と蓄積熱エネルギーの変化を比較します。不合格は簿記が閉じなかったことを意味し、上記の最終ステップ面積分メッシュ検査とは別の問いです。',
      temperatureBounds:
        '最大原理の検査: すべての節点温度は、実行に課した最冷・最熱の固定温度（および周囲シンク）の間に収まらなければなりません。不合格は節点がその物理的範囲を外れたことを意味します。',
      stress:
        '節点外挿による最大 von Mises 応力（MPa）です。相当応力であり、極限強度ではありません。メッシュや局所特異点に依存する場合があります。',
      displacement:
        '記録された最大節点変位の大きさ（mm）です。変位制限と微小変位の仮定を確認してください。求解完了だけでは巨大な変位を妥当と判断できません。',
      safety:
        '降伏強度を最大 von Mises 応力で割った値です。1 未満は不合格、1 以上 1.5 未満は要確認、1.5 以上はこの余裕の検査のみ合格です。組立全体は最弱材料を使う場合があるため、本体別結果も確認してください。',
      peak: '節点外挿 von Mises 応力が最大となる元の節点 ID です。要素 ID や積分点のピークではありません。',
      result:
        '選択した設計点の記録値を表示単位で示します。欠測はゼロではなく、値があること自体は検証合格を意味しません。',
      reaction:
        '全体座標系の支持力で、拘束方向のみを示します。共有節点は複数の支持行に含まれるため、大きさを単純合計して全体の釣り合いとしないでください。',
    },
    sweep: {
      thresholds: '降伏安全率のしきい値：1 と 1.5',
      summary: '全設計点の統計',
      completedOnly:
        '分布には完了した実行の記録値を使用します。欠損・失敗した実行も対象数に含まれます。',
      coverage: '{{n}}/{{total}} 設計点に記録あり',
      distribution: '設計点の値の分布',
      designPoint: '設計点 {{label}}',
      minimum: '最小',
      median: '中央値',
      maximum: '最大',
      pairedHelp:
        '各組は同じ設計点の独立計算とソルバー結果を比較します。異なる関係式、範囲、単位は分けて表示します。',
      noMatches:
        '{{total}} 設計点中、比較可能な組は 0 件です。下の設計点で計算を確認または生成してください。',
      matched: '{{n}}/{{total}} 設計点を比較',
      legend: '○ 予測 · ◆ 計算結果',
      pairValues: '予測 {{expected}} {{unit}}、計算結果 {{solved}} {{unit}}',
      errors: '絶対差：中央値 {{median}}%、最大 {{worst}}%（記録 {{n}} 件）',
      inspect: '設計点の比較を確認・生成',
      selectedEvidence: '選択した設計点 — 収支、反力、モード',
      checkCoverage:
        '合格 {{passed}} · 要確認 {{flagged}} · 未評価 {{missing}}',
    },
    evidence: {
      waitingForRun: 'この実行が完了すると比較を生成できます。',
      comparisonsReady:
        '{{n}} / {{total}} 件の比較が準備できました。確定した計算の編集はこのパネルに反映されます。',
      noPrimaryComparison:
        '手計算は利用できますが、この概要結果には主要な比較が関連付けられていません。',
      comparisonsNeedInputs:
        '計算は完了しましたが、対応する比較はありません。設計点で仮定と不足する入力を確認してください。',
      forceBalanceValues: '不釣合い力 {{error}} · 許容値 {{tolerance}}',
      momentBalanceTitle: '重心まわりのモーメント釣り合い',
      momentBalanceValues: '不釣合い {{error}} · 許容値 {{tolerance}}',
      appliedMoment: '作用',
      reactionMoment: '支持反力',
      cgReference: '重心 (m): {{xyz}}',
      fixtureMoment: '重心まわりのモーメント: {{value}}',
      peakStressNode: '最大 von Mises 応力の節点',
      peakDisplacementNode: '最大変位の節点',
      expectedTitle: '予測値と解析結果',
      expected: '予測値',
      expectedMissing:
        '独立した予測値がまだありません。記録された解析値を表示しています。ダッシュは不合格を意味しません。',
      safetyBands:
        '降伏安全率：1未満は不合格、1以上1.5未満は要確認、1.5以上は降伏余裕の検査に合格します。モデル全体の検証ではありません。',
      generate: '比較を生成',
      flaggedCheck:
        '{{check}} に注意が必要です。該当設計点の記録された根拠を確認してください。',
      recorded: '選択した設計点の記録された結果',
      contactSeparation: '接触面の分離',
      modesExtracted: '要求モードの抽出',
      nonPositiveModes: '非正値モードの検出',
      bucklingLoadMargin: '座屈係数が適用荷重を上回る',
      heatBalance: '境界熱流分解能',
      heatBalanceValues:
        '面積分の差 {{error}} · 許容幅 {{tolerance}}（流入 {{heatIn}} · 流出 {{heatOut}}）',
      temperatureBounds: '温度の上下限',
      surfaceFluxes: '境界面の熱流量',
      spectrum: '抽出された全モード',
      mode: 'モード {{n}}',
      modeHelp:
        '非正値の固有値または周波数の数であり、モード0ではありません。ゼロに近い正の周波数は判別しません。',
      openCalculations: '設計点を開く',
      handCalc: '手計算',
      calculationUnavailable:
        '計算を読み込めませんでした。記録された解析結果は上に表示されます。',
      noComparisons:
        'このブラウザーセッションには現在の実行の独立計算がありません。比較を生成するか、設計点で不足する仮定を入力してください。解析結果だけでは予測値を埋められません。',
      retry: '再試行',
      showLess: '比較を折りたたむ',
      showAll: '全{{count}}件の比較を表示',
      assumptions: '仮定と参考資料',
      checkSummary:
        '検査：{{passed}}件合格 · {{flagged}}件要確認 · {{missing}}件未評価',
      correctionsHelp:
        'OpenFOAMが計算値を許容範囲内に補正した記録です。数値的な保護処理であり、工学的な限界検査ではありません。収束とは別の検査です。補正後に収束する場合もあります。記録がない場合、補正がなかったとは判断できません。',
      meshRequired: '比較可能な3種類のメッシュ解像度が必要です',
    },
    jump: {
      regionLabel: '概要のセクションへ移動',
      verdict: '判定',
      trust: '信頼性',
      checks: 'チェック',
      anchors: '結果と収支',
      meshIndependence: 'メッシュ独立性',
      results: '結果',
      runHealth: '実行の状態',
      response: '応答',
      sweepResponse: 'スイープ応答',
      points: '設計点',
      evidence: '根拠',
      fields: '場の分布',
      pareto: 'パレート',
      sensitivity: '感度',
      surrogate: 'サロゲート',
      context: '背景',
      setup: 'セットアップ',
      appendix: '付録',
      comments: 'コメント',
    },
    verdict: {
      eyebrow: '判定',
      kind: {
        trustworthy: '信頼できる',
        directional: '傾向のみ',
        unusable: '使用可能な結果なし',
        nothingYet: '報告できる結果はまだありません',
      },
      headline: {
        nothingYet_one: 'まだ結果を出した実行はありません',
        nothingYet_other:
          '{{count}} 回の実行のうち、まだ結果を出したものはありません',
        unusable:
          '使用可能な結果なし — {{total}} 回中 {{failed}} 回の実行が完了しませんでした',
        trustworthy:
          '{{total}} 回中 {{completed}} 回の実行で {{ran}} 件のチェックすべてに合格',
        flagged:
          '完了した {{completed}} 回の実行のうち {{flagged}} 回が {{check}} でフラグ付き',
        qualified: '{{check}} が確定するまでは傾向のみ',
        unexamined:
          '完了した {{completed}} 回の実行にチェックが実施されていません',
      },
      why: {
        unusable: '完了した実行がないため、読み取れる応答がありません。',
        unusableReason: '最も多い失敗: {{reason}}',
        nothingYet:
          '完了も失敗もしていないため、まだ判断できるものがありません。',
        trustworthy:
          '実施したチェックはすべて合格しました。未実施の項目はスコアカードに記載されています。',
        unexamined:
          '実行は完了しましたが、チェックが読み取る信号が報告されていません。数値は未検証として扱ってください。',
        residuals:
          '収束しなかった実行は解ではなくスナップショットを報告します。その数値は答えではなく分布の一標本として扱ってください。',
        guard:
          'ソルバーは終了しましたが物理が整合していません。原因が排除されるまで結果は傾向として扱ってください。',
        massBalance:
          '領域から出る質量と入る質量が一致しません。圧力損失と流量はその行方に依存します。',
        energyBalance:
          '投入された熱量を実行が説明できていません。定常解析のエネルギー収支は解が収まってはじめて閉じるため、温度はまだ動いている解のスナップショットです。',
        bounding:
          'ソルバーが計算値を許容範囲内に補正しました。結果を利用する前に、補正が発生した場所と頻度を確認してください。',
        anchor:
          'ソルバーと手計算の差がアンカーの許容値を超えています。どちらかがセットアップを誤っています。',
        yPlus:
          '壁モデルの範囲を満たしていないため、壁近傍の力は乱流モデルの校正範囲外です。',
        meshIndependence:
          '結果がまだメッシュとともに動きます。引用する前にもう一段細分化してください。',
      },
      actions: {
        reviewFlagged: 'フラグ付きの実行を確認',
        seeFailures: '失敗グループを見る',
        openWriteup: 'レポートを開く',
        optimizeInCadMorph: 'CadMorph で最適化',
        optimizeInCadMorphHint:
          '最良の実行のジオメトリを、このスタディの目的関数・パラメータ・ドライバーを添えて開きます。',
      },
    },
    kpi: {
      best: '最良',
      bestNoteSpread: '{{dp}} · ばらつき ±{{spread}}',
      noValue: '—',
      vsHandCalc: 'vs 手計算',
      completed: '完了',
      runtime: '実行時間',
      runtimeMedian: '中央値 {{median}}',
      stripLabel: 'スイープ順の実行結果',
    },
    setup: {
      cells: '{{cells}} セル',
      cellsRange: '{{min}}–{{max}} セル',
      expand: 'セットアップを展開',
      collapse: 'セットアップを折りたたむ',
    },
    checks: {
      title: '検証チェック',
      flaggedOf: '{{total}} 件中 {{flagged}} 件にフラグ',
      allPass: '{{total}} 件すべて合格',
      empty: 'チェック対象の完了した実行がありません。',
      hidePassing_one: '合格した {{count}} 件を隠す',
      hidePassing_other: '合格した {{count}} 件を隠す',
      showPassing_one: '合格した {{count}} 件を表示',
      showPassing_other: '合格した {{count}} 件を表示',
      openFlagged: '{{detail}} →',
      label: {
        feaConvergence: '要求荷重ステップの完了',
        feaVerification: '構造検証',
        feaEquilibrium: '荷重と反力の釣り合い',
        residuals: '残差の収束',
        guard: '物理チェック',
        massBalance: '質量収支',
        energyBalance: 'エネルギー収支',
        bounding: 'ソルバーの限界補正',
        anchor: '手計算アンカー',
        yPlus: '壁面 y⁺ 分布',
        meshIndependence: 'メッシュ独立性',
      },
      state: {
        pass: '合格',
        warn: 'フラグ',
        fail: '不合格',
        notRun: '未実施',
        notApplicable: '対象外',
      },
      detail: {
        ratio: '{{n}}/{{total}}',
        runs_one: '{{count}} 回の実行',
        runs_other: '{{count}} 回の実行',
        worstPct: '最悪 {{pct}}',
        range: '{{min}}–{{max}}',
        none: 'なし',
        notRun: '未実施',
        notReported: '未報告',
        notApplicable: 'この実行には該当しません',
        residualTarget: '{{eq}} 目標 {{target}}、到達 {{achieved}}',
        residualTargetTooltip:
          '目標は、この方程式に設定されたソルバーの停止しきい値です。「到達」は最後に記録された残差です。完了したランでも反復回数の上限で停止し、目標を満たさない場合があります。停止・発散したランは検証済みの結果ではありません。',
        residualNoTargetTooltip:
          'これは最後に記録された残差です。この方程式の停止目標は報告されていないため、しきい値との比較はできません。停止・発散したランは検証済みの結果ではありません。',
        residualNoTarget: '{{eq}} 到達 {{achieved}} — 目標は未送信',
        anchorWorst: '{{pct}}',
        anchorCoverage: '{{n}}/{{total}} 件を比較',
        gci: 'GCI {{pct}}%',
      },
    },
    anchors: {
      title: '結果と収支',
      subtitle: '偏差のみ — 計算過程は各実行の手計算にあります',
      vsHand: 'vs 手計算',
      openRun: '手計算 →',
      against: '偏差は {{anchor}} に対するものです。',
      empty: 'このテンプレートに適用できる手計算アンカーはありません。',
    },
    response: {
      title: '応答',
      quantity: '量',
      sweepHeading: 'スイープ応答: ',
      vs: 'vs {{axis}}',
      pointsOf: '{{total}} 点中 {{n}} 点',
      empty:
        '実行間で変化する入力がありません — 単一点には応答曲線がありません。',
      extremes: '極値',
      min: '最小',
      max: '最大',
      missing_one: '{{count}} 点が欠落 — {{dps}} は完了しませんでした。',
      missing_other: '{{count}} 点が欠落 — {{dps}} は完了しませんでした。',
      unplaced_one:
        '{{count}} 件の実行はスイープ入力の値がないためプロットされていません — {{dps}}。',
      unplaced_other:
        '{{count}} 件の実行はスイープ入力の値がないためプロットされていません — {{dps}}。',
      unreported_one:
        '{{count}} 回の実行は完了しましたが、この出力を報告していません — {{dps}}。',
      unreported_other:
        '{{count}} 回の実行は完了しましたが、この出力を報告していません — {{dps}}。',
      whyFailed: '失敗の理由 →',
    },
    runHealth: {
      completion: '{{n}} / {{total}} 件の実行が完了',
      medianRuntime: '実行時間の中央値',
      p95Runtime: '実行時間の95パーセンタイル',
      convergence: '収束到達の報告',
      convergenceHelp:
        'ソルバーが記録した収束状態です。実行の完了や物理的検証とは別です。',
      notConverged: '完了した {{n}} 件が未収束を報告しています。',
      convergenceMissing: '完了した {{n}} 件は収束状態を報告していません。',
      title: '実行の状態',
      progressLabel: '終了した実行の割合',
      oneCause_one: '失敗の原因は 1 つです。',
      oneCause_other:
        '{{count}} 件の失敗はすべて同じ原因です。修正すればスイープの {{count}} 点が回復します。',
      manyCauses: '{{count}} 件の失敗に {{groups}} 種類の原因があります。',
      openFailures: '失敗グループを開く →',
    },
    points: {
      title: '設計点',
      fullTable: 'すべての入力を含む完全な表 →',
      run: '実行',
      status: '状態',
      deltaVsBest: '最良との Δ',
      checks: 'チェック',
      checkStateHelp:
        '未実施は、該当する検証の記録がないことを示します。対象外は、このソルバーがそのチェックを使用しないことを示します。',
      checkNotRun: '未実施 — 検証記録なし',
      notSet: '未設定または未報告',
      runtime: '実行時間',
      open: '開く →',
      openError: 'エラー →',
      best: '最良',
    },
    fields: {
      title: '場の分布 · {{dp}}',
      titleBest: '場の分布 · {{dp}}（最良の実行）',
      openViewer: 'ビューアを開く →',
    },
  },
  feaVerification: {
    axisLabel: 'チェック',
    title: '構造自己整合性チェック',
    hint: '記録済みの FEA 根拠だけを採点します。工学的な制限値がない項目は利用不可です。',
    unavailable: '利用不可',
    notEnoughAxes:
      '記録された根拠を持つ構造チェックが3項目未満のため、レーダー図を描画できません。',
    criterionLabel: '判定基準',
    evidenceLabel: '根拠',
    scoreLabel: 'スコア',
    safetyFactor: '安全率 {{value}}',
    distribution: '採点済み軸',
    worst: '最低',
    median: '中央値',
    best: '最高',
    evidence: {
      converged: '収束',
      diverged: '発散',
      closed: '全接触が閉じている',
      opened: '接触が開いた',
    },
    axes: {
      solverCompletion: 'ソルバー完了',
      reactionEquilibrium: '反力平衡',
      yieldMargin: '降伏余裕',
      ultimateMargin: '終局強度余裕',
      displacementPlausibility: '変位の妥当性',
      contactIntegrity: '接触健全性',
    },
    criteria: {
      solverCompletion: '二値判定',
      reactionEquilibrium: '±1% の釣り合い',
      yieldMargin: '安全率 1.0 → 1.5',
      ultimateMargin: '安全率 1.0 → 1.5',
      displacementPlausibility: '変位上限が必要',
      contactIntegrity: '二値判定',
    },
    tooltips: {
      solverCompletion:
        'ソルバーが収束を記録した場合は100%、発散を記録した場合は0%です。',
      reactionEquilibrium:
        '負荷合力と拘束反力を比較します。両方が記録されるまでレーダー軸を非表示にします。',
      yieldMargin:
        '降伏安全率1.0で0%、1.5で100%となる線形評価です。1.0未満は0%です。',
      ultimateMargin:
        '終局安全率1.0で0%、1.5で100%となる線形評価です。1.0未満は0%です。',
      displacementPlausibility:
        '最大変位とユーザー指定の許容変位を比較します。上限がない場合は非表示です。',
      contactIntegrity:
        '測定済みの全接触が閉じていれば100%、一つでも開けば0%です。',
    },
  },
} as const;
